"use strict";
//
// Defines the enumerations in the Common.Enum namespace.
//
// Generated File - DO NOT EDIT
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
var Common;
(function (Common) {
    let Enum;
    (function (Enum) {
        let AddressStatusType;
        (function (AddressStatusType) {
            AddressStatusType[AddressStatusType["Unconfirmed"] = 0] = "Unconfirmed";
            AddressStatusType[AddressStatusType["Confirmed"] = 1] = "Confirmed";
            AddressStatusType[AddressStatusType["UserAccepted"] = 2] = "UserAccepted";
        })(AddressStatusType = Enum.AddressStatusType || (Enum.AddressStatusType = {}));
        ;
        let AlertParameterStrings;
        (function (AlertParameterStrings) {
            AlertParameterStrings["FileName"] = "FileName";
            AlertParameterStrings["Error"] = "Error";
        })(AlertParameterStrings = Enum.AlertParameterStrings || (Enum.AlertParameterStrings = {}));
        ;
        let AsnSendResult;
        (function (AsnSendResult) {
            AsnSendResult[AsnSendResult["Unsent"] = 0] = "Unsent";
            AsnSendResult[AsnSendResult["SentSuccessfully"] = 1] = "SentSuccessfully";
            AsnSendResult[AsnSendResult["SendFailedTryAgain"] = 2] = "SendFailedTryAgain";
            AsnSendResult[AsnSendResult["SendFailedGiveUp"] = 3] = "SendFailedGiveUp";
        })(AsnSendResult = Enum.AsnSendResult || (Enum.AsnSendResult = {}));
        ;
        let AutoBatchRule;
        (function (AutoBatchRule) {
            AutoBatchRule[AutoBatchRule["Unknown"] = 0] = "Unknown";
            AutoBatchRule[AutoBatchRule["Singles"] = 1] = "Singles";
            AutoBatchRule[AutoBatchRule["SameSkuSameQty"] = 2] = "SameSkuSameQty";
            AutoBatchRule[AutoBatchRule["SameSku"] = 3] = "SameSku";
            AutoBatchRule[AutoBatchRule["Carrier"] = 4] = "Carrier";
            AutoBatchRule[AutoBatchRule["SameCustomerSameWarehouse"] = 5] = "SameCustomerSameWarehouse";
        })(AutoBatchRule = Enum.AutoBatchRule || (Enum.AutoBatchRule = {}));
        ;
        let BillableTransactionType;
        (function (BillableTransactionType) {
            BillableTransactionType[BillableTransactionType["None"] = 0] = "None";
            BillableTransactionType[BillableTransactionType["Receiver"] = 1] = "Receiver";
            BillableTransactionType[BillableTransactionType["Order"] = 2] = "Order";
            BillableTransactionType[BillableTransactionType["Adjustment"] = 4] = "Adjustment";
            BillableTransactionType[BillableTransactionType["Assembly"] = 8] = "Assembly";
            BillableTransactionType[BillableTransactionType["TransferIn"] = 16] = "TransferIn";
            BillableTransactionType[BillableTransactionType["TransferOut"] = 32] = "TransferOut";
        })(BillableTransactionType = Enum.BillableTransactionType || (Enum.BillableTransactionType = {}));
        ;
        let BillingCodeType;
        (function (BillingCodeType) {
            BillingCodeType[BillingCodeType["BillRecipient"] = 0] = "BillRecipient";
            BillingCodeType[BillingCodeType["BillThirdParty"] = 1] = "BillThirdParty";
            BillingCodeType[BillingCodeType["ConsigneeBilled"] = 2] = "ConsigneeBilled";
            BillingCodeType[BillingCodeType["FreightCollect"] = 3] = "FreightCollect";
            BillingCodeType[BillingCodeType["Prepaid"] = 4] = "Prepaid";
        })(BillingCodeType = Enum.BillingCodeType || (Enum.BillingCodeType = {}));
        ;
        let ChannelResourceType;
        (function (ChannelResourceType) {
            ChannelResourceType[ChannelResourceType["Order"] = 0] = "Order";
            ChannelResourceType[ChannelResourceType["Receiver"] = 1] = "Receiver";
            ChannelResourceType[ChannelResourceType["Item"] = 2] = "Item";
        })(ChannelResourceType = Enum.ChannelResourceType || (Enum.ChannelResourceType = {}));
        ;
        let ContactType;
        (function (ContactType) {
            ContactType[ContactType["ShipTo"] = 0] = "ShipTo";
            ContactType[ContactType["SoldTo"] = 1] = "SoldTo";
            ContactType[ContactType["BillTo"] = 2] = "BillTo";
        })(ContactType = Enum.ContactType || (Enum.ContactType = {}));
        ;
        let CostInfoApplyMethod;
        (function (CostInfoApplyMethod) {
            CostInfoApplyMethod[CostInfoApplyMethod["Each"] = 0] = "Each";
            CostInfoApplyMethod[CostInfoApplyMethod["First"] = 1] = "First";
            CostInfoApplyMethod[CostInfoApplyMethod["Prorate"] = 2] = "Prorate";
        })(CostInfoApplyMethod = Enum.CostInfoApplyMethod || (Enum.CostInfoApplyMethod = {}));
        ;
        let CountFiringChildren;
        (function (CountFiringChildren) {
            CountFiringChildren[CountFiringChildren["None"] = 0] = "None";
            CountFiringChildren[CountFiringChildren["Tasks"] = 1] = "Tasks";
            CountFiringChildren[CountFiringChildren["Mumbles"] = 2] = "Mumbles";
            CountFiringChildren[CountFiringChildren["All"] = 3] = "All";
        })(CountFiringChildren = Enum.CountFiringChildren || (Enum.CountFiringChildren = {}));
        ;
        let CountMethod;
        (function (CountMethod) {
            CountMethod[CountMethod["ABC"] = 0] = "ABC";
            CountMethod[CountMethod["Velocity"] = 1] = "Velocity";
            CountMethod[CountMethod["Cost"] = 2] = "Cost";
            CountMethod[CountMethod["Sku"] = 3] = "Sku";
            CountMethod[CountMethod["Location"] = 4] = "Location";
        })(CountMethod = Enum.CountMethod || (Enum.CountMethod = {}));
        ;
        let CountScheduleChildren;
        (function (CountScheduleChildren) {
            CountScheduleChildren[CountScheduleChildren["None"] = 0] = "None";
            CountScheduleChildren[CountScheduleChildren["Firings"] = 1] = "Firings";
            CountScheduleChildren[CountScheduleChildren["Mumbles"] = 2] = "Mumbles";
            CountScheduleChildren[CountScheduleChildren["All"] = 3] = "All";
        })(CountScheduleChildren = Enum.CountScheduleChildren || (Enum.CountScheduleChildren = {}));
        ;
        let CustomerContactType;
        (function (CustomerContactType) {
            CustomerContactType[CustomerContactType["Primary"] = 1] = "Primary";
            CustomerContactType[CustomerContactType["Invoicing"] = 2] = "Invoicing";
            CustomerContactType[CustomerContactType["Additional"] = 3] = "Additional";
            CustomerContactType[CustomerContactType["For753"] = 4] = "For753";
            CustomerContactType[CustomerContactType["SmallParcelReturnLabel"] = 5] = "SmallParcelReturnLabel";
        })(CustomerContactType = Enum.CustomerContactType || (Enum.CustomerContactType = {}));
        ;
        let CustomerSettingType;
        (function (CustomerSettingType) {
            CustomerSettingType[CustomerSettingType["RequireScacForAsn"] = 0] = "RequireScacForAsn";
            CustomerSettingType[CustomerSettingType["DashboardEnabled"] = 1] = "DashboardEnabled";
            CustomerSettingType[CustomerSettingType["AutoNormalizeOnValidation"] = 2] = "AutoNormalizeOnValidation";
            CustomerSettingType[CustomerSettingType["AsnRequireAttachedDoc"] = 3] = "AsnRequireAttachedDoc";
            CustomerSettingType[CustomerSettingType["ReallocateAtPickTimeEnabled"] = 4] = "ReallocateAtPickTimeEnabled";
            CustomerSettingType[CustomerSettingType["SuggestedPutAwayEnabled"] = 5] = "SuggestedPutAwayEnabled";
            CustomerSettingType[CustomerSettingType["UseVendorIdonBol"] = 6] = "UseVendorIdonBol";
            CustomerSettingType[CustomerSettingType["RequireTrackingNumber"] = 7] = "RequireTrackingNumber";
            CustomerSettingType[CustomerSettingType["LocationsInventory"] = 8] = "LocationsInventory";
            CustomerSettingType[CustomerSettingType["DefaultRecQty1OnMobile"] = 9] = "DefaultRecQty1OnMobile";
            CustomerSettingType[CustomerSettingType["HideMobileAutobill"] = 10] = "HideMobileAutobill";
            CustomerSettingType[CustomerSettingType["SmartPackScaleEnabled"] = 11] = "SmartPackScaleEnabled";
            CustomerSettingType[CustomerSettingType["PricingEnabled"] = 12] = "PricingEnabled";
            CustomerSettingType[CustomerSettingType["CreateMultipleDefaultOn"] = 13] = "CreateMultipleDefaultOn";
            CustomerSettingType[CustomerSettingType["CreateMultipleDefaultOff"] = 14] = "CreateMultipleDefaultOff";
            CustomerSettingType[CustomerSettingType["AutoLoadTrackBys"] = 15] = "AutoLoadTrackBys";
            CustomerSettingType[CustomerSettingType["AutoPrintCartonLabelDefault"] = 16] = "AutoPrintCartonLabelDefault";
            CustomerSettingType[CustomerSettingType["AutoConfirmOrder"] = 17] = "AutoConfirmOrder";
            CustomerSettingType[CustomerSettingType["RecalculateAutoBillCharges"] = 18] = "RecalculateAutoBillCharges";
            CustomerSettingType[CustomerSettingType["AllowPurchaseOrders"] = 19] = "AllowPurchaseOrders";
            CustomerSettingType[CustomerSettingType["HideLocationSelection"] = 20] = "HideLocationSelection";
            CustomerSettingType[CustomerSettingType["QuickBooksInstanceLocation"] = 21] = "QuickBooksInstanceLocation";
            CustomerSettingType[CustomerSettingType["QuickBooksOrderImportObject"] = 22] = "QuickBooksOrderImportObject";
            CustomerSettingType[CustomerSettingType["QuickBooksOrderImportStage"] = 23] = "QuickBooksOrderImportStage";
            CustomerSettingType[CustomerSettingType["QuickBooksOrderImportAddressMapping"] = 24] = "QuickBooksOrderImportAddressMapping";
            CustomerSettingType[CustomerSettingType["QuickBooksOrderImportDate"] = 25] = "QuickBooksOrderImportDate";
            CustomerSettingType[CustomerSettingType["QuickBooksOrderRefnumPrefix"] = 26] = "QuickBooksOrderRefnumPrefix";
            CustomerSettingType[CustomerSettingType["QuickBooksOrderTrackingUpdateDate"] = 27] = "QuickBooksOrderTrackingUpdateDate";
            CustomerSettingType[CustomerSettingType["QuickBooksCreateInvoiceFromSalesOrder"] = 28] = "QuickBooksCreateInvoiceFromSalesOrder";
            CustomerSettingType[CustomerSettingType["QuickBooksInvoiceExpFacCodeToClass"] = 29] = "QuickBooksInvoiceExpFacCodeToClass";
            CustomerSettingType[CustomerSettingType["QuickBooksInvExpGenInvNum"] = 30] = "QuickBooksInvExpGenInvNum";
            CustomerSettingType[CustomerSettingType["QuickBooksSetInvoiceDate"] = 31] = "QuickBooksSetInvoiceDate";
            CustomerSettingType[CustomerSettingType["QuickBooksSetPaymentTerms"] = 32] = "QuickBooksSetPaymentTerms";
            CustomerSettingType[CustomerSettingType["QuickBooksExcludeInvoiced"] = 33] = "QuickBooksExcludeInvoiced";
            CustomerSettingType[CustomerSettingType["QuickBooksInvoiceExpLineItemClass"] = 34] = "QuickBooksInvoiceExpLineItemClass";
            CustomerSettingType[CustomerSettingType["QuickBooksIncludePoNum"] = 35] = "QuickBooksIncludePoNum";
            CustomerSettingType[CustomerSettingType["QuickBooksIncludeRefNum"] = 36] = "QuickBooksIncludeRefNum";
            CustomerSettingType[CustomerSettingType["OrderConfirmInvoiceCreateChecked"] = 37] = "OrderConfirmInvoiceCreateChecked";
            CustomerSettingType[CustomerSettingType["ReceiverConfirmInvoiceCreateChecked"] = 38] = "ReceiverConfirmInvoiceCreateChecked";
            CustomerSettingType[CustomerSettingType["DisplayWeightFieldForReceipt"] = 39] = "DisplayWeightFieldForReceipt";
            CustomerSettingType[CustomerSettingType["SmallParcelCreatePackagesOnFind"] = 40] = "SmallParcelCreatePackagesOnFind";
            CustomerSettingType[CustomerSettingType["SmallParcelCustomizeDuties"] = 41] = "SmallParcelCustomizeDuties";
            CustomerSettingType[CustomerSettingType["SmallParcelDutiesAndTaxes"] = 42] = "SmallParcelDutiesAndTaxes";
            CustomerSettingType[CustomerSettingType["SmallParcelHighVolumeDefaultChecked"] = 43] = "SmallParcelHighVolumeDefaultChecked";
            CustomerSettingType[CustomerSettingType["SmallParcelHighVolumeZplBatched"] = 44] = "SmallParcelHighVolumeZplBatched";
            CustomerSettingType[CustomerSettingType["SmallParcelIntlDutyBillType"] = 45] = "SmallParcelIntlDutyBillType";
            CustomerSettingType[CustomerSettingType["SmallParcelRateShoppingCarrierIds"] = 46] = "SmallParcelRateShoppingCarrierIds";
            CustomerSettingType[CustomerSettingType["SmallParcelRateShoppingLogic"] = 47] = "SmallParcelRateShoppingLogic";
            CustomerSettingType[CustomerSettingType["SmallParcelReferences"] = 48] = "SmallParcelReferences";
            CustomerSettingType[CustomerSettingType["SmallParcelReturnDefaultChecked"] = 49] = "SmallParcelReturnDefaultChecked";
            CustomerSettingType[CustomerSettingType["SmallParcelReturnFedExService"] = 50] = "SmallParcelReturnFedExService";
            CustomerSettingType[CustomerSettingType["SmallParcelReturnShippingCost"] = 51] = "SmallParcelReturnShippingCost";
            CustomerSettingType[CustomerSettingType["SmallParcelReturnUpsService"] = 52] = "SmallParcelReturnUpsService";
            CustomerSettingType[CustomerSettingType["SmallParcelUspsReturnType"] = 53] = "SmallParcelUspsReturnType";
            CustomerSettingType[CustomerSettingType["SmallParcelZplPrintDefault"] = 54] = "SmallParcelZplPrintDefault";
            CustomerSettingType[CustomerSettingType["SmallParcelAutoRateShopOnShip"] = 55] = "SmallParcelAutoRateShopOnShip";
            CustomerSettingType[CustomerSettingType["SmallParcelDisableClickToPack"] = 56] = "SmallParcelDisableClickToPack";
            CustomerSettingType[CustomerSettingType["SpsCloseOnUpdate"] = 57] = "SpsCloseOnUpdate";
            CustomerSettingType[CustomerSettingType["SpsDisableAutoClearBinId"] = 58] = "SpsDisableAutoClearBinId";
            CustomerSettingType[CustomerSettingType["SmallParcelReturnPitneyExpService"] = 59] = "SmallParcelReturnPitneyExpService";
            CustomerSettingType[CustomerSettingType["SmallParcelReturnPitneyStdService"] = 60] = "SmallParcelReturnPitneyStdService";
            CustomerSettingType[CustomerSettingType["SmallParcelRateShopFilter"] = 61] = "SmallParcelRateShopFilter";
            CustomerSettingType[CustomerSettingType["QuickBooksItemExportEnabled"] = 62] = "QuickBooksItemExportEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksItemImportEnabled"] = 63] = "QuickBooksItemImportEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksItemImportAlwaysEnabled"] = 64] = "QuickBooksItemImportAlwaysEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksItemImportDate"] = 65] = "QuickBooksItemImportDate";
            CustomerSettingType[CustomerSettingType["QuickBooksItemImportIterationQty"] = 66] = "QuickBooksItemImportIterationQty";
            CustomerSettingType[CustomerSettingType["QuickBooksCustomerImportEnabled"] = 67] = "QuickBooksCustomerImportEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksCustomerImportDate"] = 68] = "QuickBooksCustomerImportDate";
            CustomerSettingType[CustomerSettingType["QuickBooksVendorImportEnabled"] = 69] = "QuickBooksVendorImportEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksVendorImportDate"] = 70] = "QuickBooksVendorImportDate";
            CustomerSettingType[CustomerSettingType["QuickBooksStockStatusEnabled"] = 71] = "QuickBooksStockStatusEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksStockStatusUpdateDate"] = 72] = "QuickBooksStockStatusUpdateDate";
            CustomerSettingType[CustomerSettingType["QuickBooksPoImportEnabled"] = 73] = "QuickBooksPoImportEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksPoImportDate"] = 74] = "QuickBooksPoImportDate";
            CustomerSettingType[CustomerSettingType["QuickBooksReceiverImportEnabled"] = 75] = "QuickBooksReceiverImportEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksReceiverImportDate"] = 76] = "QuickBooksReceiverImportDate";
            CustomerSettingType[CustomerSettingType["QuickBooksReceiverExportEnabled"] = 77] = "QuickBooksReceiverExportEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksReceiverExportUpdateQbPoEnabled"] = 78] = "QuickBooksReceiverExportUpdateQbPoEnabled";
            CustomerSettingType[CustomerSettingType["QuickBooksReceiverExportDate"] = 79] = "QuickBooksReceiverExportDate";
            CustomerSettingType[CustomerSettingType["LogoId"] = 80] = "LogoId";
            CustomerSettingType[CustomerSettingType["ThemeName"] = 81] = "ThemeName";
            CustomerSettingType[CustomerSettingType["RounduptoFullMU"] = 82] = "RounduptoFullMU";
            CustomerSettingType[CustomerSettingType["BlockStockStatus"] = 83] = "BlockStockStatus";
            CustomerSettingType[CustomerSettingType["TmwFacilityCode"] = 84] = "TmwFacilityCode";
            CustomerSettingType[CustomerSettingType["TmwShipToCode"] = 85] = "TmwShipToCode";
            CustomerSettingType[CustomerSettingType["TmwMetricDims"] = 86] = "TmwMetricDims";
            CustomerSettingType[CustomerSettingType["InheritOriginalReceiptDateOnTransfer"] = 87] = "InheritOriginalReceiptDateOnTransfer";
            CustomerSettingType[CustomerSettingType["AsnPreCheck"] = 88] = "AsnPreCheck";
            CustomerSettingType[CustomerSettingType["AsnPreCheckOrderFlexFields"] = 89] = "AsnPreCheckOrderFlexFields";
            CustomerSettingType[CustomerSettingType["AsnPreCheckOrderItemFlexFields"] = 90] = "AsnPreCheckOrderItemFlexFields";
            CustomerSettingType[CustomerSettingType["AllowDuplicateUPCs"] = 91] = "AllowDuplicateUPCs";
            CustomerSettingType[CustomerSettingType["WebHookParameters"] = 92] = "WebHookParameters";
            CustomerSettingType[CustomerSettingType["AutoAdvanceLineItem"] = 93] = "AutoAdvanceLineItem";
            CustomerSettingType[CustomerSettingType["AutoFillSameSkuAndTrackby"] = 94] = "AutoFillSameSkuAndTrackby";
            CustomerSettingType[CustomerSettingType["AllowMultiplePickers"] = 95] = "AllowMultiplePickers";
            CustomerSettingType[CustomerSettingType["AllowMovingOpenReceipts"] = 96] = "AllowMovingOpenReceipts";
            CustomerSettingType[CustomerSettingType["AutoBatchEnabled"] = 97] = "AutoBatchEnabled";
            CustomerSettingType[CustomerSettingType["AutoBatchSize"] = 98] = "AutoBatchSize";
            CustomerSettingType[CustomerSettingType["AutoBatchCutOffHour"] = 99] = "AutoBatchCutOffHour";
            CustomerSettingType[CustomerSettingType["AutoBatchCutOffMinute"] = 100] = "AutoBatchCutOffMinute";
            CustomerSettingType[CustomerSettingType["AutoBatchRules"] = 101] = "AutoBatchRules";
            CustomerSettingType[CustomerSettingType["AllowOptionalCustomFields"] = 102] = "AllowOptionalCustomFields";
            CustomerSettingType[CustomerSettingType["AllowRequiredCustomFields"] = 103] = "AllowRequiredCustomFields";
        })(CustomerSettingType = Enum.CustomerSettingType || (Enum.CustomerSettingType = {}));
        ;
        let CustomizedReportFor;
        (function (CustomizedReportFor) {
            CustomizedReportFor[CustomizedReportFor["Customer"] = 0] = "Customer";
            CustomizedReportFor[CustomizedReportFor["CustomerAny"] = 1] = "CustomerAny";
            CustomizedReportFor[CustomizedReportFor["TplOnly"] = 2] = "TplOnly";
        })(CustomizedReportFor = Enum.CustomizedReportFor || (Enum.CustomizedReportFor = {}));
        ;
        let CustomizeReportBy;
        (function (CustomizeReportBy) {
            CustomizeReportBy[CustomizeReportBy["CustomerOnly"] = 0] = "CustomerOnly";
            CustomizeReportBy[CustomizeReportBy["CustomerAnd3Pl"] = 1] = "CustomerAnd3Pl";
        })(CustomizeReportBy = Enum.CustomizeReportBy || (Enum.CustomizeReportBy = {}));
        ;
        let EmailTemplateType;
        (function (EmailTemplateType) {
            EmailTemplateType[EmailTemplateType["ItemCreateUpdate"] = 1] = "ItemCreateUpdate";
            EmailTemplateType[EmailTemplateType["Receive"] = 2] = "Receive";
            EmailTemplateType[EmailTemplateType["ReceiveConfirmation"] = 3] = "ReceiveConfirmation";
            EmailTemplateType[EmailTemplateType["OrderCreate"] = 4] = "OrderCreate";
            EmailTemplateType[EmailTemplateType["OrderUpdate"] = 5] = "OrderUpdate";
            EmailTemplateType[EmailTemplateType["CustOrderShip"] = 6] = "CustOrderShip";
            EmailTemplateType[EmailTemplateType["Adjustment"] = 7] = "Adjustment";
            EmailTemplateType[EmailTemplateType["OrderCustCreate"] = 8] = "OrderCustCreate";
            EmailTemplateType[EmailTemplateType["ShipToOrderShip"] = 9] = "ShipToOrderShip";
            EmailTemplateType[EmailTemplateType["FTPOrdImportFail"] = 10] = "FTPOrdImportFail";
            EmailTemplateType[EmailTemplateType["ASNConfNotRcvd"] = 11] = "ASNConfNotRcvd";
            EmailTemplateType[EmailTemplateType["OrdersCreateFTP"] = 12] = "OrdersCreateFTP";
            EmailTemplateType[EmailTemplateType["ItemMinReached"] = 13] = "ItemMinReached";
            EmailTemplateType[EmailTemplateType["LocMinReached"] = 14] = "LocMinReached";
            EmailTemplateType[EmailTemplateType["ASNCreate"] = 15] = "ASNCreate";
            EmailTemplateType[EmailTemplateType["OrderLoadedComplete"] = 16] = "OrderLoadedComplete";
            EmailTemplateType[EmailTemplateType["OrderLoadedIncomplete"] = 17] = "OrderLoadedIncomplete";
            EmailTemplateType[EmailTemplateType["PackedComplete"] = 18] = "PackedComplete";
            EmailTemplateType[EmailTemplateType["ProductExpiration"] = 19] = "ProductExpiration";
            EmailTemplateType[EmailTemplateType["FTPRcvImportFail"] = 26] = "FTPRcvImportFail";
            EmailTemplateType[EmailTemplateType["InvoiceDelivered"] = 27] = "InvoiceDelivered";
            EmailTemplateType[EmailTemplateType["StockStatusExportFailure"] = 28] = "StockStatusExportFailure";
            EmailTemplateType[EmailTemplateType["CustomReportExportFailure"] = 29] = "CustomReportExportFailure";
            EmailTemplateType[EmailTemplateType["ItemImportFailure"] = 30] = "ItemImportFailure";
            EmailTemplateType[EmailTemplateType["InvoicePreview"] = 33] = "InvoicePreview";
            EmailTemplateType[EmailTemplateType["InventoryOnHold"] = 34] = "InventoryOnHold";
            EmailTemplateType[EmailTemplateType["InventoryOffHold"] = 35] = "InventoryOffHold";
            EmailTemplateType[EmailTemplateType["InventoryTransferToCust"] = 36] = "InventoryTransferToCust";
            EmailTemplateType[EmailTemplateType["InventoryTransferFromCust"] = 37] = "InventoryTransferFromCust";
        })(EmailTemplateType = Enum.EmailTemplateType || (Enum.EmailTemplateType = {}));
        ;
        let EventNotifyType;
        (function (EventNotifyType) {
            EventNotifyType[EventNotifyType["DoangHair"] = 0] = "DoangHair";
            EventNotifyType[EventNotifyType["ItemCreateUpdate"] = 1] = "ItemCreateUpdate";
            EventNotifyType[EventNotifyType["Receive"] = 2] = "Receive";
            EventNotifyType[EventNotifyType["ReceiveConfirmation"] = 3] = "ReceiveConfirmation";
            EventNotifyType[EventNotifyType["OrderCreate"] = 4] = "OrderCreate";
            EventNotifyType[EventNotifyType["OrderUpdate"] = 5] = "OrderUpdate";
            EventNotifyType[EventNotifyType["CustOrderShip"] = 6] = "CustOrderShip";
            EventNotifyType[EventNotifyType["Adjustment"] = 7] = "Adjustment";
            EventNotifyType[EventNotifyType["OrderCustCreate"] = 8] = "OrderCustCreate";
            EventNotifyType[EventNotifyType["ShipToOrderShip"] = 9] = "ShipToOrderShip";
            EventNotifyType[EventNotifyType["FTPOrdImportFail"] = 10] = "FTPOrdImportFail";
            EventNotifyType[EventNotifyType["ASNConfNotRcvd"] = 11] = "ASNConfNotRcvd";
            EventNotifyType[EventNotifyType["OrdersCreateFTP"] = 12] = "OrdersCreateFTP";
            EventNotifyType[EventNotifyType["ItemMinReached"] = 13] = "ItemMinReached";
            EventNotifyType[EventNotifyType["LocMinReached"] = 14] = "LocMinReached";
            EventNotifyType[EventNotifyType["ASNCreate"] = 15] = "ASNCreate";
            EventNotifyType[EventNotifyType["OrderLoadedComplete"] = 16] = "OrderLoadedComplete";
            EventNotifyType[EventNotifyType["OrderLoadedIncomplete"] = 17] = "OrderLoadedIncomplete";
            EventNotifyType[EventNotifyType["PackedComplete"] = 18] = "PackedComplete";
            EventNotifyType[EventNotifyType["ProductExpiration"] = 19] = "ProductExpiration";
            EventNotifyType[EventNotifyType["OrderFtpOrderCreate"] = 20] = "OrderFtpOrderCreate";
            EventNotifyType[EventNotifyType["OrderFtpOrderUpdate"] = 21] = "OrderFtpOrderUpdate";
            EventNotifyType[EventNotifyType["OrderFtpOrderCancel"] = 22] = "OrderFtpOrderCancel";
            EventNotifyType[EventNotifyType["OrderFtpReceiveCreate"] = 23] = "OrderFtpReceiveCreate";
            EventNotifyType[EventNotifyType["OrderFtpReceiveUpdate"] = 24] = "OrderFtpReceiveUpdate";
            EventNotifyType[EventNotifyType["OrderFtpReceiveCancel"] = 25] = "OrderFtpReceiveCancel";
            EventNotifyType[EventNotifyType["FTPRcvImportFail"] = 26] = "FTPRcvImportFail";
            EventNotifyType[EventNotifyType["InvoiceDelivered"] = 27] = "InvoiceDelivered";
            EventNotifyType[EventNotifyType["StockStatusExportFailure"] = 28] = "StockStatusExportFailure";
            EventNotifyType[EventNotifyType["CustomReportExportFailure"] = 29] = "CustomReportExportFailure";
            EventNotifyType[EventNotifyType["ItemImportFailure"] = 30] = "ItemImportFailure";
            EventNotifyType[EventNotifyType["OrderFtpOrderConfirm"] = 31] = "OrderFtpOrderConfirm";
            EventNotifyType[EventNotifyType["OrderFtpReceiveConfirm"] = 32] = "OrderFtpReceiveConfirm";
            EventNotifyType[EventNotifyType["InvoicePreview"] = 33] = "InvoicePreview";
            EventNotifyType[EventNotifyType["InventoryOnHold"] = 34] = "InventoryOnHold";
            EventNotifyType[EventNotifyType["InventoryOffHold"] = 35] = "InventoryOffHold";
            EventNotifyType[EventNotifyType["InventoryTransferToCust"] = 36] = "InventoryTransferToCust";
            EventNotifyType[EventNotifyType["InventoryTransferFromCust"] = 37] = "InventoryTransferFromCust";
            EventNotifyType[EventNotifyType["EmailRaw"] = 38] = "EmailRaw";
            EventNotifyType[EventNotifyType["WebHook"] = 39] = "WebHook";
        })(EventNotifyType = Enum.EventNotifyType || (Enum.EventNotifyType = {}));
        ;
        let EventStrings;
        (function (EventStrings) {
            EventStrings[EventStrings["Active"] = 0] = "Active";
            EventStrings[EventStrings["AdjustmentId"] = 1] = "AdjustmentId";
            EventStrings[EventStrings["ASN"] = 2] = "ASN";
            EventStrings[EventStrings["ASNSent"] = 3] = "ASNSent";
            EventStrings[EventStrings["AssemblyId"] = 4] = "AssemblyId";
            EventStrings[EventStrings["AssignedDate"] = 5] = "AssignedDate";
            EventStrings[EventStrings["Canceled"] = 6] = "Canceled";
            EventStrings[EventStrings["ChangeMade"] = 7] = "ChangeMade";
            EventStrings[EventStrings["ChargesOnly"] = 8] = "ChargesOnly";
            EventStrings[EventStrings["Confirmed"] = 9] = "Confirmed";
            EventStrings[EventStrings["CustomerId"] = 10] = "CustomerId";
            EventStrings[EventStrings["EventTime"] = 11] = "EventTime";
            EventStrings[EventStrings["FacilityId"] = 12] = "FacilityId";
            EventStrings[EventStrings["Fulfillment"] = 13] = "Fulfillment";
            EventStrings[EventStrings["ItemId"] = 14] = "ItemId";
            EventStrings[EventStrings["LastModifiedBy"] = 15] = "LastModifiedBy";
            EventStrings[EventStrings["LoadIncomplete"] = 16] = "LoadIncomplete";
            EventStrings[EventStrings["LoadOut"] = 17] = "LoadOut";
            EventStrings[EventStrings["LocationId"] = 18] = "LocationId";
            EventStrings[EventStrings["MisPick"] = 19] = "MisPick";
            EventStrings[EventStrings["MovableUnitId"] = 20] = "MovableUnitId";
            EventStrings[EventStrings["OldFacilityId"] = 21] = "OldFacilityId";
            EventStrings[EventStrings["OldLocationId"] = 22] = "OldLocationId";
            EventStrings[EventStrings["OrderFtpId"] = 23] = "OrderFtpId";
            EventStrings[EventStrings["OrderId"] = 24] = "OrderId";
            EventStrings[EventStrings["OrderItemId"] = 25] = "OrderItemId";
            EventStrings[EventStrings["Pick"] = 26] = "Pick";
            EventStrings[EventStrings["Picker"] = 27] = "Picker";
            EventStrings[EventStrings["PickJobId"] = 28] = "PickJobId";
            EventStrings[EventStrings["PutAway"] = 29] = "PutAway";
            EventStrings[EventStrings["Qualifier"] = 30] = "Qualifier";
            EventStrings[EventStrings["QuantityAllocated"] = 31] = "QuantityAllocated";
            EventStrings[EventStrings["QuantityAvailable"] = 32] = "QuantityAvailable";
            EventStrings[EventStrings["QuantityLoaded"] = 33] = "QuantityLoaded";
            EventStrings[EventStrings["QuantityOnHand"] = 34] = "QuantityOnHand";
            EventStrings[EventStrings["QuantityOnHold"] = 35] = "QuantityOnHold";
            EventStrings[EventStrings["QuantityOrdered"] = 36] = "QuantityOrdered";
            EventStrings[EventStrings["QuantityPackedTotal"] = 37] = "QuantityPackedTotal";
            EventStrings[EventStrings["QuantityPacked"] = 38] = "QuantityPacked";
            EventStrings[EventStrings["QuantityPickedTotal"] = 39] = "QuantityPickedTotal";
            EventStrings[EventStrings["QuantityPicked"] = 40] = "QuantityPicked";
            EventStrings[EventStrings["QuantityReceived"] = 41] = "QuantityReceived";
            EventStrings[EventStrings["QuantityUnpacked"] = 42] = "QuantityUnpacked";
            EventStrings[EventStrings["QuantityUnpicked"] = 43] = "QuantityUnpicked";
            EventStrings[EventStrings["ReceiveItemId"] = 44] = "ReceiveItemId";
            EventStrings[EventStrings["Receiver"] = 45] = "Receiver";
            EventStrings[EventStrings["ReceiverId"] = 46] = "ReceiverId";
            EventStrings[EventStrings["Receiving"] = 47] = "Receiving";
            EventStrings[EventStrings["Shipped"] = 48] = "Shipped";
            EventStrings[EventStrings["Specification"] = 49] = "Specification";
            EventStrings[EventStrings["Sku"] = 50] = "Sku";
            EventStrings[EventStrings["Source"] = 51] = "Source";
            EventStrings[EventStrings["Tags"] = 52] = "Tags";
            EventStrings[EventStrings["ThreePlId"] = 53] = "ThreePlId";
            EventStrings[EventStrings["WMSEventId"] = 54] = "WMSEventId";
        })(EventStrings = Enum.EventStrings || (Enum.EventStrings = {}));
        ;
        let EventTopic;
        (function (EventTopic) {
            EventTopic[EventTopic["Nothing"] = 0] = "Nothing";
            EventTopic[EventTopic["Order"] = 1] = "Order";
            EventTopic[EventTopic["Receiver"] = 2] = "Receiver";
            EventTopic[EventTopic["Adjustment"] = 3] = "Adjustment";
            EventTopic[EventTopic["Assembly"] = 4] = "Assembly";
            EventTopic[EventTopic["InventorySummary"] = 5] = "InventorySummary";
            EventTopic[EventTopic["StockMove"] = 6] = "StockMove";
            EventTopic[EventTopic["Item"] = 7] = "Item";
            EventTopic[EventTopic["Customer"] = 8] = "Customer";
            EventTopic[EventTopic["Facility"] = 9] = "Facility";
            EventTopic[EventTopic["MovableUnit"] = 10] = "MovableUnit";
            EventTopic[EventTopic["Location"] = 11] = "Location";
            EventTopic[EventTopic["ThreePl"] = 12] = "ThreePl";
            EventTopic[EventTopic["OrderItem"] = 13] = "OrderItem";
            EventTopic[EventTopic["ReceiveItem"] = 14] = "ReceiveItem";
            EventTopic[EventTopic["Allocation"] = 15] = "Allocation";
            EventTopic[EventTopic["User"] = 16] = "User";
        })(EventTopic = Enum.EventTopic || (Enum.EventTopic = {}));
        ;
        let EventType;
        (function (EventType) {
            EventType[EventType["OrderCreate"] = 0] = "OrderCreate";
            EventType[EventType["OrderComplete"] = 1] = "OrderComplete";
            EventType[EventType["OrderUpdate"] = 2] = "OrderUpdate";
            EventType[EventType["OrderConfirm"] = 3] = "OrderConfirm";
            EventType[EventType["OrderUnconfirm"] = 4] = "OrderUnconfirm";
            EventType[EventType["OrderCancel"] = 5] = "OrderCancel";
            EventType[EventType["OrderDelete"] = 6] = "OrderDelete";
            EventType[EventType["OrderFullyAllocated"] = 7] = "OrderFullyAllocated";
            EventType[EventType["OrdersCreate"] = 8] = "OrdersCreate";
            EventType[EventType["ReceiverCreate"] = 9] = "ReceiverCreate";
            EventType[EventType["ReceiverComplete"] = 10] = "ReceiverComplete";
            EventType[EventType["ReceiverUpdate"] = 11] = "ReceiverUpdate";
            EventType[EventType["ReceiverConfirm"] = 12] = "ReceiverConfirm";
            EventType[EventType["ReceiverUnconfirm"] = 13] = "ReceiverUnconfirm";
            EventType[EventType["ReceiverCancel"] = 14] = "ReceiverCancel";
            EventType[EventType["ReceiverDelete"] = 15] = "ReceiverDelete";
            EventType[EventType["ReceiverStarted"] = 16] = "ReceiverStarted";
            EventType[EventType["ReceiverPaused"] = 17] = "ReceiverPaused";
            EventType[EventType["ReceiverResumed"] = 18] = "ReceiverResumed";
            EventType[EventType["ReceiverFinished"] = 19] = "ReceiverFinished";
            EventType[EventType["ReceiveItemProcessed"] = 20] = "ReceiveItemProcessed";
            EventType[EventType["AdjustmentCreate"] = 21] = "AdjustmentCreate";
            EventType[EventType["AdjustmentConfirm"] = 22] = "AdjustmentConfirm";
            EventType[EventType["AdjustmentCancel"] = 23] = "AdjustmentCancel";
            EventType[EventType["AdjustmentDelete"] = 24] = "AdjustmentDelete";
            EventType[EventType["AdjustmentUpdate"] = 25] = "AdjustmentUpdate";
            EventType[EventType["AssemblyCreate"] = 26] = "AssemblyCreate";
            EventType[EventType["AssemblyCancel"] = 27] = "AssemblyCancel";
            EventType[EventType["AssemblyDelete"] = 28] = "AssemblyDelete";
            EventType[EventType["AssemblyUpdate"] = 29] = "AssemblyUpdate";
            EventType[EventType["AssemblyConfirm"] = 30] = "AssemblyConfirm";
            EventType[EventType["AcknowledgementNotReceived"] = 31] = "AcknowledgementNotReceived";
            EventType[EventType["ProductExpiration"] = 32] = "ProductExpiration";
            EventType[EventType["ItemCreate"] = 33] = "ItemCreate";
            EventType[EventType["ItemUpdate"] = 34] = "ItemUpdate";
            EventType[EventType["ItemDelete"] = 35] = "ItemDelete";
            EventType[EventType["OrderIncludedInPickJob"] = 36] = "OrderIncludedInPickJob";
            EventType[EventType["OrderExcludedFromPickJob"] = 37] = "OrderExcludedFromPickJob";
            EventType[EventType["OrderPickJobUserAssigned"] = 38] = "OrderPickJobUserAssigned";
            EventType[EventType["OrderPickJobUserUnassigned"] = 39] = "OrderPickJobUserUnassigned";
            EventType[EventType["OrderPickJobDone"] = 40] = "OrderPickJobDone";
            EventType[EventType["OrderPickJobLoaded"] = 41] = "OrderPickJobLoaded";
            EventType[EventType["OrderPickStarted"] = 42] = "OrderPickStarted";
            EventType[EventType["OrderPickPaused"] = 43] = "OrderPickPaused";
            EventType[EventType["OrderPickResumed"] = 44] = "OrderPickResumed";
            EventType[EventType["OrderItemPick"] = 45] = "OrderItemPick";
            EventType[EventType["OrderItemUnpick"] = 46] = "OrderItemUnpick";
            EventType[EventType["OrderItemLoaded"] = 47] = "OrderItemLoaded";
            EventType[EventType["OrderPackStarted"] = 48] = "OrderPackStarted";
            EventType[EventType["OrderPacked"] = 49] = "OrderPacked";
            EventType[EventType["OrderPackPaused"] = 50] = "OrderPackPaused";
            EventType[EventType["OrderPackResumed"] = 51] = "OrderPackResumed";
            EventType[EventType["OrderItemPack"] = 52] = "OrderItemPack";
            EventType[EventType["OrderItemUnpack"] = 53] = "OrderItemUnpack";
            EventType[EventType["ItemMinReached"] = 54] = "ItemMinReached";
            EventType[EventType["LocMinReached"] = 55] = "LocMinReached";
            EventType[EventType["InventorySummaryUpdate"] = 56] = "InventorySummaryUpdate";
            EventType[EventType["CustomerCreate"] = 57] = "CustomerCreate";
            EventType[EventType["CustomerUpdate"] = 58] = "CustomerUpdate";
            EventType[EventType["CustomerDelete"] = 59] = "CustomerDelete";
            EventType[EventType["FacilityCreate"] = 60] = "FacilityCreate";
            EventType[EventType["FacilityUpdate"] = 61] = "FacilityUpdate";
            EventType[EventType["FacilityDelete"] = 62] = "FacilityDelete";
            EventType[EventType["LocationCreate"] = 63] = "LocationCreate";
            EventType[EventType["LocationUpdate"] = 64] = "LocationUpdate";
            EventType[EventType["LocationDelete"] = 65] = "LocationDelete";
            EventType[EventType["MovableUnitCreate"] = 66] = "MovableUnitCreate";
            EventType[EventType["MovableUnitUpdate"] = 67] = "MovableUnitUpdate";
            EventType[EventType["MovableUnitDelete"] = 68] = "MovableUnitDelete";
            EventType[EventType["OrderItemCreate"] = 69] = "OrderItemCreate";
            EventType[EventType["OrderItemUpdate"] = 70] = "OrderItemUpdate";
            EventType[EventType["OrderItemDelete"] = 71] = "OrderItemDelete";
            EventType[EventType["ReceiveItemMove"] = 72] = "ReceiveItemMove";
            EventType[EventType["ReceiveItemCreate"] = 73] = "ReceiveItemCreate";
            EventType[EventType["ReceiveItemUpdate"] = 74] = "ReceiveItemUpdate";
            EventType[EventType["ReceiveItemDelete"] = 75] = "ReceiveItemDelete";
            EventType[EventType["AllocationCreate"] = 76] = "AllocationCreate";
            EventType[EventType["AllocationUpdate"] = 77] = "AllocationUpdate";
            EventType[EventType["AllocationDelete"] = 78] = "AllocationDelete";
            EventType[EventType["ThreePlUpdate"] = 79] = "ThreePlUpdate";
            EventType[EventType["MobileUserAvailable"] = 80] = "MobileUserAvailable";
            EventType[EventType["MobileUserUnavailable"] = 81] = "MobileUserUnavailable";
        })(EventType = Enum.EventType || (Enum.EventType = {}));
        ;
        let ExportFileFormat;
        (function (ExportFileFormat) {
            ExportFileFormat[ExportFileFormat["Edi"] = 0] = "Edi";
            ExportFileFormat[ExportFileFormat["Xml"] = 1] = "Xml";
            ExportFileFormat[ExportFileFormat["Tab"] = 2] = "Tab";
            ExportFileFormat[ExportFileFormat["TabDetailed"] = 3] = "TabDetailed";
        })(ExportFileFormat = Enum.ExportFileFormat || (Enum.ExportFileFormat = {}));
        ;
        let FilterOperator;
        (function (FilterOperator) {
            FilterOperator[FilterOperator["Less"] = 0] = "Less";
            FilterOperator[FilterOperator["LessOrEqual"] = 1] = "LessOrEqual";
            FilterOperator[FilterOperator["Equals"] = 2] = "Equals";
            FilterOperator[FilterOperator["NotEquals"] = 3] = "NotEquals";
            FilterOperator[FilterOperator["GreaterOrEqual"] = 4] = "GreaterOrEqual";
            FilterOperator[FilterOperator["Greater"] = 5] = "Greater";
            FilterOperator[FilterOperator["StartsWith"] = 6] = "StartsWith";
            FilterOperator[FilterOperator["EndsWith"] = 7] = "EndsWith";
            FilterOperator[FilterOperator["Contains"] = 8] = "Contains";
            FilterOperator[FilterOperator["ContainedIn"] = 9] = "ContainedIn";
            FilterOperator[FilterOperator["NotContains"] = 10] = "NotContains";
        })(FilterOperator = Enum.FilterOperator || (Enum.FilterOperator = {}));
        ;
        let Frequency;
        (function (Frequency) {
            Frequency[Frequency["Annually"] = 0] = "Annually";
            Frequency[Frequency["SemiAnnually"] = 1] = "SemiAnnually";
            Frequency[Frequency["Quarterly"] = 2] = "Quarterly";
            Frequency[Frequency["BiMonthly"] = 3] = "BiMonthly";
            Frequency[Frequency["Monthly"] = 4] = "Monthly";
            Frequency[Frequency["SemiMonthly"] = 5] = "SemiMonthly";
            Frequency[Frequency["Weekly"] = 6] = "Weekly";
            Frequency[Frequency["Once"] = 7] = "Once";
        })(Frequency = Enum.Frequency || (Enum.Frequency = {}));
        ;
        let FromFileContent;
        (function (FromFileContent) {
            FromFileContent[FromFileContent["Unspecified"] = -1] = "Unspecified";
            FromFileContent[FromFileContent["Order"] = 0] = "Order";
            FromFileContent[FromFileContent["Receiver"] = 1] = "Receiver";
            FromFileContent[FromFileContent["Item"] = 2] = "Item";
            FromFileContent[FromFileContent["PurchaseOrder"] = 3] = "PurchaseOrder";
            FromFileContent[FromFileContent["Assembly"] = 4] = "Assembly";
        })(FromFileContent = Enum.FromFileContent || (Enum.FromFileContent = {}));
        ;
        let FtpClientType;
        (function (FtpClientType) {
            FtpClientType[FtpClientType["FtpNone"] = 0] = "FtpNone";
            FtpClientType[FtpClientType["FtpWebRequestClient"] = 1] = "FtpWebRequestClient";
            FtpClientType[FtpClientType["FtpClientSsh"] = 2] = "FtpClientSsh";
            FtpClientType[FtpClientType["FtpClientWinInet"] = 3] = "FtpClientWinInet";
            FtpClientType[FtpClientType["FtpClientFake"] = 4] = "FtpClientFake";
            FtpClientType[FtpClientType["FtpClientExceptionFake"] = 5] = "FtpClientExceptionFake";
            FtpClientType[FtpClientType["FtpClientFluent"] = 6] = "FtpClientFluent";
        })(FtpClientType = Enum.FtpClientType || (Enum.FtpClientType = {}));
        ;
        let FtpImportType;
        (function (FtpImportType) {
            FtpImportType[FtpImportType["Unspecified"] = -1] = "Unspecified";
            FtpImportType[FtpImportType["UNDERMIN"] = 0] = "UNDERMIN";
            FtpImportType[FtpImportType["Order"] = 1] = "Order";
            FtpImportType[FtpImportType["Receiver"] = 2] = "Receiver";
            FtpImportType[FtpImportType["StockStatus"] = 3] = "StockStatus";
            FtpImportType[FtpImportType["BasicConnection"] = 4] = "BasicConnection";
            FtpImportType[FtpImportType["Item"] = 5] = "Item";
            FtpImportType[FtpImportType["OVERMAX"] = 6] = "OVERMAX";
            FtpImportType[FtpImportType["PurchaseOrder"] = 7] = "PurchaseOrder";
            FtpImportType[FtpImportType["OVERMAX2"] = 8] = "OVERMAX2";
        })(FtpImportType = Enum.FtpImportType || (Enum.FtpImportType = {}));
        ;
        let FulfillmentInvoicing;
        (function (FulfillmentInvoicing) {
            FulfillmentInvoicing[FulfillmentInvoicing["Disabled"] = 0] = "Disabled";
            FulfillmentInvoicing[FulfillmentInvoicing["Enabled"] = 1] = "Enabled";
            FulfillmentInvoicing[FulfillmentInvoicing["Prepopulated"] = 2] = "Prepopulated";
        })(FulfillmentInvoicing = Enum.FulfillmentInvoicing || (Enum.FulfillmentInvoicing = {}));
        ;
        let HandlerStrings;
        (function (HandlerStrings) {
            HandlerStrings["AllHandlers"] = "ALL";
            HandlerStrings["ThreeplCentralBilling"] = "ThreeplCentralBilling";
            HandlerStrings["TplCentralBillingPassword"] = "TplCentralBillingPassword";
            HandlerStrings["SmtpServers"] = "smtpServers";
        })(HandlerStrings = Enum.HandlerStrings || (Enum.HandlerStrings = {}));
        ;
        let HeadlessHorsemanStrings;
        (function (HeadlessHorsemanStrings) {
            HeadlessHorsemanStrings["RecurringJobId"] = "RecurringJobId";
            HeadlessHorsemanStrings["RegisteredByHangfireJobId"] = "registeredByJobId";
            HeadlessHorsemanStrings["RetryCount"] = "RetryCount";
            HeadlessHorsemanStrings["TplGuid"] = "tplguid";
            HeadlessHorsemanStrings["OtherJobParameters"] = "other";
        })(HeadlessHorsemanStrings = Enum.HeadlessHorsemanStrings || (Enum.HeadlessHorsemanStrings = {}));
        ;
        let ImperialUnitsOfLength;
        (function (ImperialUnitsOfLength) {
            ImperialUnitsOfLength[ImperialUnitsOfLength["Inches"] = 0] = "Inches";
            ImperialUnitsOfLength[ImperialUnitsOfLength["Feet"] = 1] = "Feet";
            ImperialUnitsOfLength[ImperialUnitsOfLength["Yards"] = 2] = "Yards";
        })(ImperialUnitsOfLength = Enum.ImperialUnitsOfLength || (Enum.ImperialUnitsOfLength = {}));
        ;
        let ImperialUnitsOfMass;
        (function (ImperialUnitsOfMass) {
            ImperialUnitsOfMass[ImperialUnitsOfMass["Ounces"] = 0] = "Ounces";
            ImperialUnitsOfMass[ImperialUnitsOfMass["Pounds"] = 1] = "Pounds";
            ImperialUnitsOfMass[ImperialUnitsOfMass["Tons"] = 2] = "Tons";
        })(ImperialUnitsOfMass = Enum.ImperialUnitsOfMass || (Enum.ImperialUnitsOfMass = {}));
        ;
        let ImportExportContentType;
        (function (ImportExportContentType) {
            ImportExportContentType[ImportExportContentType["GenericMainObject"] = 0] = "GenericMainObject";
            ImportExportContentType[ImportExportContentType["GenericSecondaryObject"] = 1] = "GenericSecondaryObject";
            ImportExportContentType[ImportExportContentType["MovableUnits"] = 2] = "MovableUnits";
            ImportExportContentType[ImportExportContentType["Packages"] = 3] = "Packages";
            ImportExportContentType[ImportExportContentType["ItemsToCreate"] = 4] = "ItemsToCreate";
            ImportExportContentType[ImportExportContentType["WarehouseTransactions"] = 5] = "WarehouseTransactions";
            ImportExportContentType[ImportExportContentType["GroupedItems"] = 6] = "GroupedItems";
            ImportExportContentType[ImportExportContentType["Orders"] = 7] = "Orders";
            ImportExportContentType[ImportExportContentType["Receivers"] = 8] = "Receivers";
            ImportExportContentType[ImportExportContentType["GroupedRecItems"] = 9] = "GroupedRecItems";
            ImportExportContentType[ImportExportContentType["GroupedOrdItems"] = 10] = "GroupedOrdItems";
            ImportExportContentType[ImportExportContentType["AssemblyItems"] = 11] = "AssemblyItems";
            ImportExportContentType[ImportExportContentType["Faults"] = 12] = "Faults";
        })(ImportExportContentType = Enum.ImportExportContentType || (Enum.ImportExportContentType = {}));
        ;
        let ImportExportDocumentType;
        (function (ImportExportDocumentType) {
            ImportExportDocumentType[ImportExportDocumentType["Order"] = 0] = "Order";
            ImportExportDocumentType[ImportExportDocumentType["AdvanceShippingNotice"] = 1] = "AdvanceShippingNotice";
            ImportExportDocumentType[ImportExportDocumentType["RoutingRequest"] = 2] = "RoutingRequest";
            ImportExportDocumentType[ImportExportDocumentType["Receiver"] = 3] = "Receiver";
            ImportExportDocumentType[ImportExportDocumentType["ReceiptAdvice"] = 4] = "ReceiptAdvice";
            ImportExportDocumentType[ImportExportDocumentType["AdjustmentAdvice"] = 5] = "AdjustmentAdvice";
            ImportExportDocumentType[ImportExportDocumentType["Invoice"] = 6] = "Invoice";
            ImportExportDocumentType[ImportExportDocumentType["PurchaseOrder"] = 7] = "PurchaseOrder";
            ImportExportDocumentType[ImportExportDocumentType["StockStatus"] = 8] = "StockStatus";
            ImportExportDocumentType[ImportExportDocumentType["FreightRateRequest"] = 9] = "FreightRateRequest";
            ImportExportDocumentType[ImportExportDocumentType["FreightRateResponse"] = 10] = "FreightRateResponse";
            ImportExportDocumentType[ImportExportDocumentType["ItemImport"] = 11] = "ItemImport";
            ImportExportDocumentType[ImportExportDocumentType["ItemExport"] = 12] = "ItemExport";
            ImportExportDocumentType[ImportExportDocumentType["ReceiverConfirmation"] = 13] = "ReceiverConfirmation";
            ImportExportDocumentType[ImportExportDocumentType["OrderConfirmation"] = 14] = "OrderConfirmation";
            ImportExportDocumentType[ImportExportDocumentType["AssemblyImport"] = 15] = "AssemblyImport";
        })(ImportExportDocumentType = Enum.ImportExportDocumentType || (Enum.ImportExportDocumentType = {}));
        ;
        let ImportExportModuleType;
        (function (ImportExportModuleType) {
            ImportExportModuleType[ImportExportModuleType["OrderImport"] = 0] = "OrderImport";
            ImportExportModuleType[ImportExportModuleType["OrderExport"] = 1] = "OrderExport";
            ImportExportModuleType[ImportExportModuleType["ReceiverImport"] = 2] = "ReceiverImport";
            ImportExportModuleType[ImportExportModuleType["ReceiverExport"] = 3] = "ReceiverExport";
            ImportExportModuleType[ImportExportModuleType["AdjustmentExport"] = 4] = "AdjustmentExport";
            ImportExportModuleType[ImportExportModuleType["PurchaseOrderImport"] = 5] = "PurchaseOrderImport";
            ImportExportModuleType[ImportExportModuleType["StockStatusExport"] = 6] = "StockStatusExport";
            ImportExportModuleType[ImportExportModuleType["ItemDescriptionImport"] = 7] = "ItemDescriptionImport";
            ImportExportModuleType[ImportExportModuleType["ItemDescriptionExport"] = 8] = "ItemDescriptionExport";
            ImportExportModuleType[ImportExportModuleType["AssemblyImport"] = 9] = "AssemblyImport";
        })(ImportExportModuleType = Enum.ImportExportModuleType || (Enum.ImportExportModuleType = {}));
        ;
        let ImportExportResourceType;
        (function (ImportExportResourceType) {
            ImportExportResourceType[ImportExportResourceType["Order"] = 0] = "Order";
            ImportExportResourceType[ImportExportResourceType["Receiver"] = 1] = "Receiver";
            ImportExportResourceType[ImportExportResourceType["Adjustment"] = 2] = "Adjustment";
            ImportExportResourceType[ImportExportResourceType["PurchaseOrder"] = 3] = "PurchaseOrder";
            ImportExportResourceType[ImportExportResourceType["StockStatus"] = 4] = "StockStatus";
            ImportExportResourceType[ImportExportResourceType["Item"] = 5] = "Item";
        })(ImportExportResourceType = Enum.ImportExportResourceType || (Enum.ImportExportResourceType = {}));
        ;
        let InputParserFormatType;
        (function (InputParserFormatType) {
            InputParserFormatType[InputParserFormatType["EDI"] = 0] = "EDI";
            InputParserFormatType[InputParserFormatType["TabDelim"] = 1] = "TabDelim";
            InputParserFormatType[InputParserFormatType["XML"] = 2] = "XML";
            InputParserFormatType[InputParserFormatType["Unknown"] = 3] = "Unknown";
        })(InputParserFormatType = Enum.InputParserFormatType || (Enum.InputParserFormatType = {}));
        ;
        let InventoryAuditStatus;
        (function (InventoryAuditStatus) {
            InventoryAuditStatus[InventoryAuditStatus["Open"] = 0] = "Open";
            InventoryAuditStatus[InventoryAuditStatus["Counting"] = 1] = "Counting";
            InventoryAuditStatus[InventoryAuditStatus["Counted"] = 2] = "Counted";
            InventoryAuditStatus[InventoryAuditStatus["Closed"] = 3] = "Closed";
        })(InventoryAuditStatus = Enum.InventoryAuditStatus || (Enum.InventoryAuditStatus = {}));
        ;
        let InventoryMethodEnum;
        (function (InventoryMethodEnum) {
            InventoryMethodEnum[InventoryMethodEnum["FIFO"] = 1] = "FIFO";
            InventoryMethodEnum[InventoryMethodEnum["LIFO"] = 2] = "LIFO";
            InventoryMethodEnum[InventoryMethodEnum["FEFO"] = 3] = "FEFO";
        })(InventoryMethodEnum = Enum.InventoryMethodEnum || (Enum.InventoryMethodEnum = {}));
        ;
        let InvoiceType;
        (function (InvoiceType) {
            InvoiceType[InvoiceType["Simple"] = 0] = "Simple";
            InvoiceType[InvoiceType["Detail"] = 1] = "Detail";
            InvoiceType[InvoiceType["UltraDetail"] = 2] = "UltraDetail";
            InvoiceType[InvoiceType["UnitsOnly"] = 3] = "UnitsOnly";
            InvoiceType[InvoiceType["ChrgAlw"] = 4] = "ChrgAlw";
        })(InvoiceType = Enum.InvoiceType || (Enum.InvoiceType = {}));
        ;
        let ItemRatesUpdateType;
        (function (ItemRatesUpdateType) {
            ItemRatesUpdateType[ItemRatesUpdateType["None"] = 0] = "None";
            ItemRatesUpdateType[ItemRatesUpdateType["XactionRates"] = 1] = "XactionRates";
            ItemRatesUpdateType[ItemRatesUpdateType["StorageRates"] = 2] = "StorageRates";
            ItemRatesUpdateType[ItemRatesUpdateType["All"] = 3] = "All";
        })(ItemRatesUpdateType = Enum.ItemRatesUpdateType || (Enum.ItemRatesUpdateType = {}));
        ;
        let ItemSettingType;
        (function (ItemSettingType) {
            ItemSettingType[ItemSettingType["OutboundMobileSerializationBehavior"] = 0] = "OutboundMobileSerializationBehavior";
            ItemSettingType[ItemSettingType["StorageChargeMin"] = 1] = "StorageChargeMin";
            ItemSettingType[ItemSettingType["StorageChargeMinMonthsToSkip"] = 2] = "StorageChargeMinMonthsToSkip";
        })(ItemSettingType = Enum.ItemSettingType || (Enum.ItemSettingType = {}));
        ;
        let JobState;
        (function (JobState) {
            JobState[JobState["Scheduled"] = 1] = "Scheduled";
            JobState[JobState["Enqueued"] = 2] = "Enqueued";
            JobState[JobState["Processing"] = 3] = "Processing";
            JobState[JobState["Succeeded"] = 4] = "Succeeded";
            JobState[JobState["Failed"] = 5] = "Failed";
            JobState[JobState["Deleted"] = 6] = "Deleted";
        })(JobState = Enum.JobState || (Enum.JobState = {}));
        ;
        let JobType;
        (function (JobType) {
            JobType[JobType["Test"] = 0] = "Test";
            JobType[JobType["NoOp"] = 1] = "NoOp";
            JobType[JobType["HttpRequest"] = 2] = "HttpRequest";
            JobType[JobType["CompletedJob"] = 3] = "CompletedJob";
            JobType[JobType["HungJob"] = 4] = "HungJob";
            JobType[JobType["HandledEvent"] = 5] = "HandledEvent";
            JobType[JobType["HungEvent"] = 6] = "HungEvent";
        })(JobType = Enum.JobType || (Enum.JobType = {}));
        ;
        let LabelFormatType;
        (function (LabelFormatType) {
            LabelFormatType[LabelFormatType["Zpl"] = 0] = "Zpl";
            LabelFormatType[LabelFormatType["Png"] = 1] = "Png";
            LabelFormatType[LabelFormatType["Pdf"] = 2] = "Pdf";
        })(LabelFormatType = Enum.LabelFormatType || (Enum.LabelFormatType = {}));
        ;
        let ListAsyncStatusDetail;
        (function (ListAsyncStatusDetail) {
            ListAsyncStatusDetail[ListAsyncStatusDetail["Status"] = 0] = "Status";
            ListAsyncStatusDetail[ListAsyncStatusDetail["All"] = 1] = "All";
        })(ListAsyncStatusDetail = Enum.ListAsyncStatusDetail || (Enum.ListAsyncStatusDetail = {}));
        ;
        let LocationTypeEnum;
        (function (LocationTypeEnum) {
            LocationTypeEnum[LocationTypeEnum["Null"] = 0] = "Null";
            LocationTypeEnum[LocationTypeEnum["StorageLocation"] = 1] = "StorageLocation";
            LocationTypeEnum[LocationTypeEnum["StagingArea"] = 2] = "StagingArea";
            LocationTypeEnum[LocationTypeEnum["PutAwayVehicle"] = 3] = "PutAwayVehicle";
            LocationTypeEnum[LocationTypeEnum["Quarantine"] = 4] = "Quarantine";
            LocationTypeEnum[LocationTypeEnum["PickLine"] = 5] = "PickLine";
        })(LocationTypeEnum = Enum.LocationTypeEnum || (Enum.LocationTypeEnum = {}));
        ;
        let LogicalOperator;
        (function (LogicalOperator) {
            LogicalOperator[LogicalOperator["And"] = 0] = "And";
            LogicalOperator[LogicalOperator["Or"] = 1] = "Or";
        })(LogicalOperator = Enum.LogicalOperator || (Enum.LogicalOperator = {}));
        ;
        let MeasurementSystemType;
        (function (MeasurementSystemType) {
            MeasurementSystemType[MeasurementSystemType["USImperial"] = 0] = "USImperial";
            MeasurementSystemType[MeasurementSystemType["Metric"] = 1] = "Metric";
        })(MeasurementSystemType = Enum.MeasurementSystemType || (Enum.MeasurementSystemType = {}));
        ;
        let MetricUnitsOfLength;
        (function (MetricUnitsOfLength) {
            MetricUnitsOfLength[MetricUnitsOfLength["Millimeters"] = 0] = "Millimeters";
            MetricUnitsOfLength[MetricUnitsOfLength["Centimeters"] = 1] = "Centimeters";
            MetricUnitsOfLength[MetricUnitsOfLength["Meters"] = 2] = "Meters";
        })(MetricUnitsOfLength = Enum.MetricUnitsOfLength || (Enum.MetricUnitsOfLength = {}));
        ;
        let MetricUnitsOfMass;
        (function (MetricUnitsOfMass) {
            MetricUnitsOfMass[MetricUnitsOfMass["Grams"] = 0] = "Grams";
            MetricUnitsOfMass[MetricUnitsOfMass["Kilograms"] = 1] = "Kilograms";
        })(MetricUnitsOfMass = Enum.MetricUnitsOfMass || (Enum.MetricUnitsOfMass = {}));
        ;
        let MovableUnitStrings;
        (function (MovableUnitStrings) {
            MovableUnitStrings["SystemSet"] = "systemset";
            MovableUnitStrings["SystemAssigned"] = "system assigned";
            MovableUnitStrings["None"] = "none";
        })(MovableUnitStrings = Enum.MovableUnitStrings || (Enum.MovableUnitStrings = {}));
        ;
        let NotifyDestinationType;
        (function (NotifyDestinationType) {
            NotifyDestinationType[NotifyDestinationType["DoangHair"] = 0] = "DoangHair";
            NotifyDestinationType[NotifyDestinationType["SimpleEmail"] = 1] = "SimpleEmail";
            NotifyDestinationType[NotifyDestinationType["ExportEmail"] = 2] = "ExportEmail";
            NotifyDestinationType[NotifyDestinationType["CombinedEmail"] = 3] = "CombinedEmail";
            NotifyDestinationType[NotifyDestinationType["FTP"] = 4] = "FTP";
            NotifyDestinationType[NotifyDestinationType["WebService"] = 5] = "WebService";
        })(NotifyDestinationType = Enum.NotifyDestinationType || (Enum.NotifyDestinationType = {}));
        ;
        let OrderChildren;
        (function (OrderChildren) {
            OrderChildren[OrderChildren["None"] = 0] = "None";
            OrderChildren[OrderChildren["OrderItems"] = 1] = "OrderItems";
            OrderChildren[OrderChildren["BillingDetails"] = 2] = "BillingDetails";
            OrderChildren[OrderChildren["SavedElements"] = 4] = "SavedElements";
            OrderChildren[OrderChildren["Packages"] = 8] = "Packages";
            OrderChildren[OrderChildren["Contacts"] = 16] = "Contacts";
            OrderChildren[OrderChildren["ProposedBilling"] = 32] = "ProposedBilling";
            OrderChildren[OrderChildren["OutboundSerialNumbers"] = 64] = "OutboundSerialNumbers";
            OrderChildren[OrderChildren["SmallParcel"] = 128] = "SmallParcel";
            OrderChildren[OrderChildren["ParcelOptions"] = 256] = "ParcelOptions";
            OrderChildren[OrderChildren["All"] = 351] = "All";
        })(OrderChildren = Enum.OrderChildren || (Enum.OrderChildren = {}));
        ;
        let OrderItemChildren;
        (function (OrderItemChildren) {
            OrderItemChildren[OrderItemChildren["None"] = 0] = "None";
            OrderItemChildren[OrderItemChildren["SavedElements"] = 1] = "SavedElements";
            OrderItemChildren[OrderItemChildren["Allocations"] = 2] = "Allocations";
            OrderItemChildren[OrderItemChildren["All"] = 3] = "All";
            OrderItemChildren[OrderItemChildren["AllocationsWithDetail"] = 4] = "AllocationsWithDetail";
        })(OrderItemChildren = Enum.OrderItemChildren || (Enum.OrderItemChildren = {}));
        ;
        let OrderTransportType;
        (function (OrderTransportType) {
            OrderTransportType[OrderTransportType["Unspecified"] = -1] = "Unspecified";
            OrderTransportType[OrderTransportType["UNDERMIN"] = 0] = "UNDERMIN";
            OrderTransportType[OrderTransportType["Ftp"] = 1] = "Ftp";
            OrderTransportType[OrderTransportType["VolusionWebService"] = 2] = "VolusionWebService";
            OrderTransportType[OrderTransportType["Email"] = 3] = "Email";
            OrderTransportType[OrderTransportType["EBayWebService"] = 4] = "EBayWebService";
            OrderTransportType[OrderTransportType["TI"] = 5] = "TI";
            OrderTransportType[OrderTransportType["StockStatusExport"] = 6] = "StockStatusExport";
            OrderTransportType[OrderTransportType["EventNotifyOrderCreate"] = 7] = "EventNotifyOrderCreate";
            OrderTransportType[OrderTransportType["EventNotifyOrderUpdate"] = 8] = "EventNotifyOrderUpdate";
            OrderTransportType[OrderTransportType["EventNotifyOrderCancel"] = 9] = "EventNotifyOrderCancel";
            OrderTransportType[OrderTransportType["EventNotifyReceiveCreate"] = 10] = "EventNotifyReceiveCreate";
            OrderTransportType[OrderTransportType["EventNotifyReceiveUpdate"] = 11] = "EventNotifyReceiveUpdate";
            OrderTransportType[OrderTransportType["EventNotifyReceiveCancel"] = 12] = "EventNotifyReceiveCancel";
            OrderTransportType[OrderTransportType["CustomReportExport"] = 13] = "CustomReportExport";
            OrderTransportType[OrderTransportType["ImportMasterExport"] = 14] = "ImportMasterExport";
            OrderTransportType[OrderTransportType["AmazonWebService"] = 15] = "AmazonWebService";
            OrderTransportType[OrderTransportType["ChannelAdvisorWebService"] = 16] = "ChannelAdvisorWebService";
            OrderTransportType[OrderTransportType["BrightPearlWebService"] = 17] = "BrightPearlWebService";
            OrderTransportType[OrderTransportType["WooCommerce"] = 18] = "WooCommerce";
            OrderTransportType[OrderTransportType["EventNotifyOrderConfirm"] = 19] = "EventNotifyOrderConfirm";
            OrderTransportType[OrderTransportType["EventNotifyReceiveConfirm"] = 20] = "EventNotifyReceiveConfirm";
            OrderTransportType[OrderTransportType["SmsaService"] = 21] = "SmsaService";
            OrderTransportType[OrderTransportType["Magento2X"] = 22] = "Magento2X";
            OrderTransportType[OrderTransportType["DataDump"] = 23] = "DataDump";
            OrderTransportType[OrderTransportType["Shopify"] = 24] = "Shopify";
            OrderTransportType[OrderTransportType["EbayRest"] = 25] = "EbayRest";
            OrderTransportType[OrderTransportType["ShipStation"] = 26] = "ShipStation";
            OrderTransportType[OrderTransportType["SmsaService2"] = 27] = "SmsaService2";
            OrderTransportType[OrderTransportType["OrderConfirmSummary"] = 28] = "OrderConfirmSummary";
            OrderTransportType[OrderTransportType["OVERMAX"] = 29] = "OVERMAX";
        })(OrderTransportType = Enum.OrderTransportType || (Enum.OrderTransportType = {}));
        ;
        let OutboundMobileSerializationBehavior;
        (function (OutboundMobileSerializationBehavior) {
            OutboundMobileSerializationBehavior[OutboundMobileSerializationBehavior["Disabled"] = 0] = "Disabled";
            OutboundMobileSerializationBehavior[OutboundMobileSerializationBehavior["IgnoreQuantityMismatches"] = 1] = "IgnoreQuantityMismatches";
            OutboundMobileSerializationBehavior[OutboundMobileSerializationBehavior["DisallowQuantityMismatches"] = 2] = "DisallowQuantityMismatches";
        })(OutboundMobileSerializationBehavior = Enum.OutboundMobileSerializationBehavior || (Enum.OutboundMobileSerializationBehavior = {}));
        ;
        let PackingListAddressSource;
        (function (PackingListAddressSource) {
            PackingListAddressSource[PackingListAddressSource["ShipTo"] = 0] = "ShipTo";
            PackingListAddressSource[PackingListAddressSource["Warehouse"] = 1] = "Warehouse";
            PackingListAddressSource[PackingListAddressSource["CustomerContact"] = 2] = "CustomerContact";
            PackingListAddressSource[PackingListAddressSource["SavedElements"] = 3] = "SavedElements";
            PackingListAddressSource[PackingListAddressSource["BillTo"] = 4] = "BillTo";
            PackingListAddressSource[PackingListAddressSource["SoldTo"] = 5] = "SoldTo";
        })(PackingListAddressSource = Enum.PackingListAddressSource || (Enum.PackingListAddressSource = {}));
        ;
        let PackingListCustomerContactType;
        (function (PackingListCustomerContactType) {
            PackingListCustomerContactType[PackingListCustomerContactType["Contact1"] = 0] = "Contact1";
            PackingListCustomerContactType[PackingListCustomerContactType["Contact2"] = 1] = "Contact2";
            PackingListCustomerContactType[PackingListCustomerContactType["Primary"] = 2] = "Primary";
            PackingListCustomerContactType[PackingListCustomerContactType["Invoicing"] = 3] = "Invoicing";
            PackingListCustomerContactType[PackingListCustomerContactType["Additional"] = 4] = "Additional";
            PackingListCustomerContactType[PackingListCustomerContactType["For753"] = 5] = "For753";
        })(PackingListCustomerContactType = Enum.PackingListCustomerContactType || (Enum.PackingListCustomerContactType = {}));
        ;
        let ParcelApiProvider;
        (function (ParcelApiProvider) {
            ParcelApiProvider[ParcelApiProvider["ShipEngine"] = 0] = "ShipEngine";
            ParcelApiProvider[ParcelApiProvider["PitneyBowes"] = 1] = "PitneyBowes";
            ParcelApiProvider[ParcelApiProvider["BukuShip"] = 2] = "BukuShip";
        })(ParcelApiProvider = Enum.ParcelApiProvider || (Enum.ParcelApiProvider = {}));
        ;
        let ParcelConfirmationEnum;
        (function (ParcelConfirmationEnum) {
            ParcelConfirmationEnum[ParcelConfirmationEnum["none"] = 0] = "none";
            ParcelConfirmationEnum[ParcelConfirmationEnum["delivery"] = 1] = "delivery";
            ParcelConfirmationEnum[ParcelConfirmationEnum["signature"] = 2] = "signature";
            ParcelConfirmationEnum[ParcelConfirmationEnum["adult_signature"] = 3] = "adult_signature";
            ParcelConfirmationEnum[ParcelConfirmationEnum["direct_signature"] = 4] = "direct_signature";
        })(ParcelConfirmationEnum = Enum.ParcelConfirmationEnum || (Enum.ParcelConfirmationEnum = {}));
        ;
        let ParcelLabelType;
        (function (ParcelLabelType) {
            ParcelLabelType[ParcelLabelType["None"] = 0] = "None";
            ParcelLabelType[ParcelLabelType["Pdf"] = 1] = "Pdf";
            ParcelLabelType[ParcelLabelType["Zpl"] = 2] = "Zpl";
        })(ParcelLabelType = Enum.ParcelLabelType || (Enum.ParcelLabelType = {}));
        ;
        let ParcelOptionType;
        (function (ParcelOptionType) {
            ParcelOptionType[ParcelOptionType["BillAccountCountry"] = 0] = "BillAccountCountry";
            ParcelOptionType[ParcelOptionType["BillAccountNbr"] = 1] = "BillAccountNbr";
            ParcelOptionType[ParcelOptionType["BillAccountZipCode"] = 2] = "BillAccountZipCode";
            ParcelOptionType[ParcelOptionType["DeliveryConfirmationType"] = 3] = "DeliveryConfirmationType";
            ParcelOptionType[ParcelOptionType["DeliveredDutyPaid"] = 4] = "DeliveredDutyPaid";
            ParcelOptionType[ParcelOptionType["DropShipAddress1"] = 5] = "DropShipAddress1";
            ParcelOptionType[ParcelOptionType["DropShipAddress2"] = 6] = "DropShipAddress2";
            ParcelOptionType[ParcelOptionType["DropShipCity"] = 7] = "DropShipCity";
            ParcelOptionType[ParcelOptionType["DropShipCompanyName"] = 8] = "DropShipCompanyName";
            ParcelOptionType[ParcelOptionType["DropShipCountry"] = 9] = "DropShipCountry";
            ParcelOptionType[ParcelOptionType["DropShipName"] = 10] = "DropShipName";
            ParcelOptionType[ParcelOptionType["DropShipPhoneNumber1"] = 11] = "DropShipPhoneNumber1";
            ParcelOptionType[ParcelOptionType["DropShipState"] = 12] = "DropShipState";
            ParcelOptionType[ParcelOptionType["DropShipZip"] = 13] = "DropShipZip";
            ParcelOptionType[ParcelOptionType["DryIceWeight"] = 14] = "DryIceWeight";
            ParcelOptionType[ParcelOptionType["InsuranceAmount"] = 15] = "InsuranceAmount";
            ParcelOptionType[ParcelOptionType["InsuranceType"] = 16] = "InsuranceType";
            ParcelOptionType[ParcelOptionType["InternationalContentsType"] = 17] = "InternationalContentsType";
            ParcelOptionType[ParcelOptionType["InternationalNonDelivery"] = 18] = "InternationalNonDelivery";
            ParcelOptionType[ParcelOptionType["RequireReturnLabel"] = 19] = "RequireReturnLabel";
            ParcelOptionType[ParcelOptionType["ResidentialFlag"] = 20] = "ResidentialFlag";
            ParcelOptionType[ParcelOptionType["SaturdayDeliveryFlag"] = 21] = "SaturdayDeliveryFlag";
            ParcelOptionType[ParcelOptionType["ServiceCode"] = 22] = "ServiceCode";
            ParcelOptionType[ParcelOptionType["ShipEngineCarrierId"] = 23] = "ShipEngineCarrierId";
            ParcelOptionType[ParcelOptionType["TaxIdentifiers"] = 24] = "TaxIdentifiers";
        })(ParcelOptionType = Enum.ParcelOptionType || (Enum.ParcelOptionType = {}));
        ;
        let ParcelPartner;
        (function (ParcelPartner) {
            ParcelPartner[ParcelPartner["Abol"] = 0] = "Abol";
            ParcelPartner[ParcelPartner["ShipEngine"] = 1] = "ShipEngine";
            ParcelPartner[ParcelPartner["ParcelApi"] = 2] = "ParcelApi";
        })(ParcelPartner = Enum.ParcelPartner || (Enum.ParcelPartner = {}));
        ;
        let ParcelTypeEnum;
        (function (ParcelTypeEnum) {
            ParcelTypeEnum[ParcelTypeEnum["Ship"] = 0] = "Ship";
            ParcelTypeEnum[ParcelTypeEnum["Void"] = 1] = "Void";
            ParcelTypeEnum[ParcelTypeEnum["Return"] = 2] = "Return";
            ParcelTypeEnum[ParcelTypeEnum["Manifest"] = 3] = "Manifest";
            ParcelTypeEnum[ParcelTypeEnum["Rate"] = 4] = "Rate";
            ParcelTypeEnum[ParcelTypeEnum["Reprint"] = 5] = "Reprint";
            ParcelTypeEnum[ParcelTypeEnum["CarrierAccount"] = 6] = "CarrierAccount";
            ParcelTypeEnum[ParcelTypeEnum["CarrierAccountDelete"] = 7] = "CarrierAccountDelete";
            ParcelTypeEnum[ParcelTypeEnum["CarrierAccountSettingsGet"] = 8] = "CarrierAccountSettingsGet";
            ParcelTypeEnum[ParcelTypeEnum["CarrierAccountSettingsUpdate"] = 9] = "CarrierAccountSettingsUpdate";
            ParcelTypeEnum[ParcelTypeEnum["ManifestsGet"] = 10] = "ManifestsGet";
            ParcelTypeEnum[ParcelTypeEnum["BatchesGet"] = 11] = "BatchesGet";
            ParcelTypeEnum[ParcelTypeEnum["BatchGet"] = 12] = "BatchGet";
            ParcelTypeEnum[ParcelTypeEnum["BatchLabelsPut"] = 13] = "BatchLabelsPut";
            ParcelTypeEnum[ParcelTypeEnum["BatchErrorsGet"] = 14] = "BatchErrorsGet";
            ParcelTypeEnum[ParcelTypeEnum["ContainerManifest"] = 15] = "ContainerManifest";
        })(ParcelTypeEnum = Enum.ParcelTypeEnum || (Enum.ParcelTypeEnum = {}));
        ;
        let PrepopulateCarrierInfo;
        (function (PrepopulateCarrierInfo) {
            PrepopulateCarrierInfo[PrepopulateCarrierInfo["Off"] = 0] = "Off";
            PrepopulateCarrierInfo[PrepopulateCarrierInfo["On"] = 1] = "On";
            PrepopulateCarrierInfo[PrepopulateCarrierInfo["PrepaidOnly"] = 2] = "PrepaidOnly";
            PrepopulateCarrierInfo[PrepopulateCarrierInfo["ThirdPartyOnly"] = 3] = "ThirdPartyOnly";
        })(PrepopulateCarrierInfo = Enum.PrepopulateCarrierInfo || (Enum.PrepopulateCarrierInfo = {}));
        ;
        let PriceCalcFieldType;
        (function (PriceCalcFieldType) {
            PriceCalcFieldType[PriceCalcFieldType["Handling"] = 1] = "Handling";
            PriceCalcFieldType[PriceCalcFieldType["Storage"] = 2] = "Storage";
            PriceCalcFieldType[PriceCalcFieldType["PrepaidFreight"] = 3] = "PrepaidFreight";
            PriceCalcFieldType[PriceCalcFieldType["ThirdPartyFreight"] = 4] = "ThirdPartyFreight";
            PriceCalcFieldType[PriceCalcFieldType["SpecialCharges"] = 5] = "SpecialCharges";
            PriceCalcFieldType[PriceCalcFieldType["Materials"] = 6] = "Materials";
            PriceCalcFieldType[PriceCalcFieldType["AutoCalcStorage"] = 7] = "AutoCalcStorage";
            PriceCalcFieldType[PriceCalcFieldType["AutoCalcHandling"] = 8] = "AutoCalcHandling";
            PriceCalcFieldType[PriceCalcFieldType["MAXVAL"] = 8] = "MAXVAL";
        })(PriceCalcFieldType = Enum.PriceCalcFieldType || (Enum.PriceCalcFieldType = {}));
        ;
        let QbEnabled;
        (function (QbEnabled) {
            QbEnabled[QbEnabled["Off"] = 0] = "Off";
            QbEnabled[QbEnabled["Desktop"] = 1] = "Desktop";
            QbEnabled[QbEnabled["Online"] = 2] = "Online";
        })(QbEnabled = Enum.QbEnabled || (Enum.QbEnabled = {}));
        ;
        let ReceiveAgainstAsns;
        (function (ReceiveAgainstAsns) {
            ReceiveAgainstAsns[ReceiveAgainstAsns["Disabled"] = 0] = "Disabled";
            ReceiveAgainstAsns[ReceiveAgainstAsns["Enabled"] = 1] = "Enabled";
            ReceiveAgainstAsns[ReceiveAgainstAsns["Blind"] = 2] = "Blind";
        })(ReceiveAgainstAsns = Enum.ReceiveAgainstAsns || (Enum.ReceiveAgainstAsns = {}));
        ;
        let ReceiveItemChildren;
        (function (ReceiveItemChildren) {
            ReceiveItemChildren[ReceiveItemChildren["None"] = 0] = "None";
            ReceiveItemChildren[ReceiveItemChildren["SavedElements"] = 1] = "SavedElements";
            ReceiveItemChildren[ReceiveItemChildren["All"] = 1] = "All";
        })(ReceiveItemChildren = Enum.ReceiveItemChildren || (Enum.ReceiveItemChildren = {}));
        ;
        let ReceiverChildren;
        (function (ReceiverChildren) {
            ReceiverChildren[ReceiverChildren["None"] = 0] = "None";
            ReceiverChildren[ReceiverChildren["ReceiveItems"] = 1] = "ReceiveItems";
            ReceiverChildren[ReceiverChildren["BillingDetails"] = 2] = "BillingDetails";
            ReceiverChildren[ReceiverChildren["SavedElements"] = 4] = "SavedElements";
            ReceiverChildren[ReceiverChildren["ProposedBilling"] = 8] = "ProposedBilling";
            ReceiverChildren[ReceiverChildren["All"] = 7] = "All";
        })(ReceiverChildren = Enum.ReceiverChildren || (Enum.ReceiverChildren = {}));
        ;
        let ReceiverType;
        (function (ReceiverType) {
            ReceiverType[ReceiverType["Normal"] = 0] = "Normal";
            ReceiverType[ReceiverType["Return"] = 1] = "Return";
            ReceiverType[ReceiverType["ReceiveAgainst"] = 2] = "ReceiveAgainst";
            ReceiverType[ReceiverType["OnlyASNs"] = 3] = "OnlyASNs";
            ReceiverType[ReceiverType["AllButASNs"] = 4] = "AllButASNs";
        })(ReceiverType = Enum.ReceiverType || (Enum.ReceiverType = {}));
        ;
        let ScriptType;
        (function (ScriptType) {
            ScriptType[ScriptType["ChargeDetail"] = 1] = "ChargeDetail";
            ScriptType[ScriptType["ChargeTypeTotal"] = 2] = "ChargeTypeTotal";
            ScriptType[ScriptType["TransactionTotal"] = 3] = "TransactionTotal";
            ScriptType[ScriptType["AutoBillStorageCountInv"] = 4] = "AutoBillStorageCountInv";
        })(ScriptType = Enum.ScriptType || (Enum.ScriptType = {}));
        ;
        let SerialNumberUsageLevel;
        (function (SerialNumberUsageLevel) {
            SerialNumberUsageLevel[SerialNumberUsageLevel["Disallow"] = 0] = "Disallow";
            SerialNumberUsageLevel[SerialNumberUsageLevel["Allow"] = 1] = "Allow";
            SerialNumberUsageLevel[SerialNumberUsageLevel["AllowUnique"] = 2] = "AllowUnique";
            SerialNumberUsageLevel[SerialNumberUsageLevel["Require"] = 3] = "Require";
            SerialNumberUsageLevel[SerialNumberUsageLevel["RequireUnique"] = 4] = "RequireUnique";
        })(SerialNumberUsageLevel = Enum.SerialNumberUsageLevel || (Enum.SerialNumberUsageLevel = {}));
        ;
        let StorageChargePeriodType;
        (function (StorageChargePeriodType) {
            StorageChargePeriodType[StorageChargePeriodType["NotApplicable"] = 0] = "NotApplicable";
            StorageChargePeriodType[StorageChargePeriodType["Monthly"] = 1] = "Monthly";
            StorageChargePeriodType[StorageChargePeriodType["SemiMonthly"] = 2] = "SemiMonthly";
            StorageChargePeriodType[StorageChargePeriodType["Weekly"] = 3] = "Weekly";
        })(StorageChargePeriodType = Enum.StorageChargePeriodType || (Enum.StorageChargePeriodType = {}));
        ;
        let StorageWhichDaysToCountType;
        (function (StorageWhichDaysToCountType) {
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["EndOfPeriod"] = 0] = "EndOfPeriod";
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["TwiceInPeriod"] = 1] = "TwiceInPeriod";
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["EachWeek"] = 2] = "EachWeek";
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["EachDay"] = 3] = "EachDay";
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["Monthiversary"] = 4] = "Monthiversary";
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["Weekiversary"] = 5] = "Weekiversary";
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["SevenDayAnniversary"] = 6] = "SevenDayAnniversary";
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["FifteenDayAnniversary"] = 7] = "FifteenDayAnniversary";
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["ThirtyDayAnniversary"] = 8] = "ThirtyDayAnniversary";
            StorageWhichDaysToCountType[StorageWhichDaysToCountType["TwentyOneDayAnniversary"] = 9] = "TwentyOneDayAnniversary";
        })(StorageWhichDaysToCountType = Enum.StorageWhichDaysToCountType || (Enum.StorageWhichDaysToCountType = {}));
        ;
        let SubType;
        (function (SubType) {
            SubType[SubType["None"] = 0] = "None";
            SubType[SubType["TransferTo"] = 1] = "TransferTo";
            SubType[SubType["TransferFrom"] = 2] = "TransferFrom";
        })(SubType = Enum.SubType || (Enum.SubType = {}));
        ;
        let TemperatureSystem;
        (function (TemperatureSystem) {
            TemperatureSystem[TemperatureSystem["Fahrenheit"] = 0] = "Fahrenheit";
            TemperatureSystem[TemperatureSystem["Celsius"] = 1] = "Celsius";
        })(TemperatureSystem = Enum.TemperatureSystem || (Enum.TemperatureSystem = {}));
        ;
        let TemplateType;
        (function (TemplateType) {
            TemplateType[TemplateType["Receipt"] = 0] = "Receipt";
            TemplateType[TemplateType["Move"] = 1] = "Move";
            TemplateType[TemplateType["Loadout"] = 2] = "Loadout";
        })(TemplateType = Enum.TemplateType || (Enum.TemplateType = {}));
        ;
        let ThreePlRecordStatus;
        (function (ThreePlRecordStatus) {
            ThreePlRecordStatus[ThreePlRecordStatus["NewRecord"] = 0] = "NewRecord";
            ThreePlRecordStatus[ThreePlRecordStatus["ConfEmailSent"] = 1] = "ConfEmailSent";
            ThreePlRecordStatus[ThreePlRecordStatus["ReadyToCreateDb"] = 2] = "ReadyToCreateDb";
            ThreePlRecordStatus[ThreePlRecordStatus["DbCreated"] = 3] = "DbCreated";
            ThreePlRecordStatus[ThreePlRecordStatus["Deactivated"] = 4] = "Deactivated";
        })(ThreePlRecordStatus = Enum.ThreePlRecordStatus || (Enum.ThreePlRecordStatus = {}));
        ;
        let ThreePlSettingType;
        (function (ThreePlSettingType) {
            ThreePlSettingType[ThreePlSettingType["LogoId"] = 0] = "LogoId";
            ThreePlSettingType[ThreePlSettingType["ThemeName"] = 1] = "ThemeName";
            ThreePlSettingType[ThreePlSettingType["QbEnabled"] = 2] = "QbEnabled";
            ThreePlSettingType[ThreePlSettingType["AutoReallocOnReceiveEnabled"] = 3] = "AutoReallocOnReceiveEnabled";
            ThreePlSettingType[ThreePlSettingType["SuggestedPutAwayEnabled"] = 4] = "SuggestedPutAwayEnabled";
            ThreePlSettingType[ThreePlSettingType["MobileEnabled"] = 5] = "MobileEnabled";
            ThreePlSettingType[ThreePlSettingType["DashboardEnabled"] = 6] = "DashboardEnabled";
            ThreePlSettingType[ThreePlSettingType["ReallocateAtPickTimeEnabled"] = 7] = "ReallocateAtPickTimeEnabled";
            ThreePlSettingType[ThreePlSettingType["HideHelpVideos"] = 8] = "HideHelpVideos";
            ThreePlSettingType[ThreePlSettingType["DefaultBrandingImage"] = 9] = "DefaultBrandingImage";
            ThreePlSettingType[ThreePlSettingType["CustomerItemMarkupEnabled"] = 10] = "CustomerItemMarkupEnabled";
            ThreePlSettingType[ThreePlSettingType["ItemClassificationEnabled"] = 11] = "ItemClassificationEnabled";
            ThreePlSettingType[ThreePlSettingType["PricingEnabled"] = 12] = "PricingEnabled";
            ThreePlSettingType[ThreePlSettingType["AllowAllocatedStockMoveEnabled"] = 13] = "AllowAllocatedStockMoveEnabled";
            ThreePlSettingType[ThreePlSettingType["ConsolidateAsnEnabled"] = 14] = "ConsolidateAsnEnabled";
            ThreePlSettingType[ThreePlSettingType["SkuAliasEnabled"] = 15] = "SkuAliasEnabled";
            ThreePlSettingType[ThreePlSettingType["ConnectionsEnabled"] = 16] = "ConnectionsEnabled";
            ThreePlSettingType[ThreePlSettingType["ItemImagesEnabled"] = 17] = "ItemImagesEnabled";
            ThreePlSettingType[ThreePlSettingType["SmallParcelEnabled"] = 18] = "SmallParcelEnabled";
            ThreePlSettingType[ThreePlSettingType["SmallParcelRateShoppingEnabled"] = 19] = "SmallParcelRateShoppingEnabled";
            ThreePlSettingType[ThreePlSettingType["SmallParcelEula"] = 20] = "SmallParcelEula";
            ThreePlSettingType[ThreePlSettingType["CustomPickEnabled"] = 21] = "CustomPickEnabled";
            ThreePlSettingType[ThreePlSettingType["BillToEnabled"] = 22] = "BillToEnabled";
            ThreePlSettingType[ThreePlSettingType["FindOrderSkuSearchEnabled"] = 23] = "FindOrderSkuSearchEnabled";
            ThreePlSettingType[ThreePlSettingType["UspsEnabled"] = 24] = "UspsEnabled";
            ThreePlSettingType[ThreePlSettingType["AddressValidationEnabled"] = 25] = "AddressValidationEnabled";
            ThreePlSettingType[ThreePlSettingType["AliasOverAllocateCheckOnImport"] = 26] = "AliasOverAllocateCheckOnImport";
            ThreePlSettingType[ThreePlSettingType["AutoSetArrivalDate"] = 27] = "AutoSetArrivalDate";
            ThreePlSettingType[ThreePlSettingType["ItemOverAllocateCheckOnImport"] = 28] = "ItemOverAllocateCheckOnImport";
            ThreePlSettingType[ThreePlSettingType["OutboundMobileSerializationEnabled"] = 29] = "OutboundMobileSerializationEnabled";
            ThreePlSettingType[ThreePlSettingType["PrintOverAllocPickTickets"] = 30] = "PrintOverAllocPickTickets";
            ThreePlSettingType[ThreePlSettingType["ShowZeroHandlingCharges"] = 31] = "ShowZeroHandlingCharges";
            ThreePlSettingType[ThreePlSettingType["CheckBeforeMassConfirm"] = 32] = "CheckBeforeMassConfirm";
            ThreePlSettingType[ThreePlSettingType["QbAuthToken"] = 33] = "QbAuthToken";
            ThreePlSettingType[ThreePlSettingType["QbOnlineCanadianTax"] = 34] = "QbOnlineCanadianTax";
            ThreePlSettingType[ThreePlSettingType["ErpEnabled"] = 35] = "ErpEnabled";
            ThreePlSettingType[ThreePlSettingType["ExternalSoapOverAllocatedCheckOnCreateOrder"] = 36] = "ExternalSoapOverAllocatedCheckOnCreateOrder";
            ThreePlSettingType[ThreePlSettingType["ErpAdditionsEnabled"] = 37] = "ErpAdditionsEnabled";
            ThreePlSettingType[ThreePlSettingType["SmallParcelReturnLabelEnabled"] = 38] = "SmallParcelReturnLabelEnabled";
            ThreePlSettingType[ThreePlSettingType["SmallParcelHighVolumeProcessing"] = 39] = "SmallParcelHighVolumeProcessing";
            ThreePlSettingType[ThreePlSettingType["SmallParcelMultipleAccounts"] = 40] = "SmallParcelMultipleAccounts";
            ThreePlSettingType[ThreePlSettingType["TrackBysEditEnabled"] = 41] = "TrackBysEditEnabled";
            ThreePlSettingType[ThreePlSettingType["ZoneBillingEnabled"] = 42] = "ZoneBillingEnabled";
            ThreePlSettingType[ThreePlSettingType["SmallParcelPackageSplit"] = 43] = "SmallParcelPackageSplit";
            ThreePlSettingType[ThreePlSettingType["UseShipMethodMappings"] = 44] = "UseShipMethodMappings";
            ThreePlSettingType[ThreePlSettingType["ShowCycleCountMenuInV1"] = 45] = "ShowCycleCountMenuInV1";
            ThreePlSettingType[ThreePlSettingType["IntegratedLabelEnabled"] = 46] = "IntegratedLabelEnabled";
            ThreePlSettingType[ThreePlSettingType["IntegratedLabelSplit"] = 47] = "IntegratedLabelSplit";
            ThreePlSettingType[ThreePlSettingType["SemiAutoMonthlyBillingEnable"] = 48] = "SemiAutoMonthlyBillingEnable";
            ThreePlSettingType[ThreePlSettingType["SmartPackScaleEnabled"] = 49] = "SmartPackScaleEnabled";
            ThreePlSettingType[ThreePlSettingType["DirectedPutAwayEnabled"] = 50] = "DirectedPutAwayEnabled";
            ThreePlSettingType[ThreePlSettingType["V1UiAppNameAlternate"] = 51] = "V1UiAppNameAlternate";
            ThreePlSettingType[ThreePlSettingType["UseNewStockStatus"] = 52] = "UseNewStockStatus";
            ThreePlSettingType[ThreePlSettingType["SaasShipmentWebServiceAuth"] = 53] = "SaasShipmentWebServiceAuth";
            ThreePlSettingType[ThreePlSettingType["QueueInvoiceEnable"] = 54] = "QueueInvoiceEnable";
            ThreePlSettingType[ThreePlSettingType["MoveFacilityEnabled"] = 55] = "MoveFacilityEnabled";
            ThreePlSettingType[ThreePlSettingType["AutoBatchEnabled"] = 56] = "AutoBatchEnabled";
            ThreePlSettingType[ThreePlSettingType["SmallParcelCreatePackagesOnFind"] = 57] = "SmallParcelCreatePackagesOnFind";
            ThreePlSettingType[ThreePlSettingType["TmsEnabled"] = 58] = "TmsEnabled";
            ThreePlSettingType[ThreePlSettingType["EfsTmsEndPoint"] = 59] = "EfsTmsEndPoint";
            ThreePlSettingType[ThreePlSettingType["WeDontWantRecurringBillingDetails"] = 60] = "WeDontWantRecurringBillingDetails";
            ThreePlSettingType[ThreePlSettingType["SmartViewAccess"] = 61] = "SmartViewAccess";
            ThreePlSettingType[ThreePlSettingType["TmwExportEnabled"] = 62] = "TmwExportEnabled";
            ThreePlSettingType[ThreePlSettingType["TmwUsername"] = 63] = "TmwUsername";
            ThreePlSettingType[ThreePlSettingType["TmwPassword"] = 64] = "TmwPassword";
            ThreePlSettingType[ThreePlSettingType["TmwFreightUrl"] = 65] = "TmwFreightUrl";
            ThreePlSettingType[ThreePlSettingType["TmwProfileUrl"] = 66] = "TmwProfileUrl";
            ThreePlSettingType[ThreePlSettingType["TmwSiteId"] = 67] = "TmwSiteId";
            ThreePlSettingType[ThreePlSettingType["TmwSession"] = 68] = "TmwSession";
            ThreePlSettingType[ThreePlSettingType["ExternalLoggerEnabled"] = 69] = "ExternalLoggerEnabled";
            ThreePlSettingType[ThreePlSettingType["SmallParcelZPLPrintDefault"] = 70] = "SmallParcelZPLPrintDefault";
            ThreePlSettingType[ThreePlSettingType["UxPrototypingDirectives"] = 71] = "UxPrototypingDirectives";
            ThreePlSettingType[ThreePlSettingType["UsesHeadlessHorsemanForEventQueueNotification"] = 72] = "UsesHeadlessHorsemanForEventQueueNotification";
            ThreePlSettingType[ThreePlSettingType["SmallParcelPartner"] = 73] = "SmallParcelPartner";
            ThreePlSettingType[ThreePlSettingType["QbOAuth2TokenInfo"] = 74] = "QbOAuth2TokenInfo";
            ThreePlSettingType[ThreePlSettingType["SmallParcelShipEngineAccountId"] = 75] = "SmallParcelShipEngineAccountId";
            ThreePlSettingType[ThreePlSettingType["SmallParcelApiProvider"] = 76] = "SmallParcelApiProvider";
            ThreePlSettingType[ThreePlSettingType["SmallParcelApiEnvironment"] = 77] = "SmallParcelApiEnvironment";
            ThreePlSettingType[ThreePlSettingType["SmallParcelShipEngineHighVolumeBatches"] = 78] = "SmallParcelShipEngineHighVolumeBatches";
            ThreePlSettingType[ThreePlSettingType["SmallParcelTestModeEnabled"] = 79] = "SmallParcelTestModeEnabled";
            ThreePlSettingType[ThreePlSettingType["EditableOptions"] = 80] = "EditableOptions";
            ThreePlSettingType[ThreePlSettingType["WebHookParameters"] = 81] = "WebHookParameters";
            ThreePlSettingType[ThreePlSettingType["FindOrdersAutoBatchEnabled"] = 82] = "FindOrdersAutoBatchEnabled";
        })(ThreePlSettingType = Enum.ThreePlSettingType || (Enum.ThreePlSettingType = {}));
        ;
        let ToFileContent;
        (function (ToFileContent) {
            ToFileContent[ToFileContent["Unspecified"] = -1] = "Unspecified";
            ToFileContent[ToFileContent["AdvanceShippingNotice"] = 0] = "AdvanceShippingNotice";
            ToFileContent[ToFileContent["RoutingRequest"] = 1] = "RoutingRequest";
            ToFileContent[ToFileContent["ReceiptAdvice"] = 2] = "ReceiptAdvice";
            ToFileContent[ToFileContent["AdjustmentAdvice"] = 3] = "AdjustmentAdvice";
            ToFileContent[ToFileContent["Invoice"] = 4] = "Invoice";
            ToFileContent[ToFileContent["StockStatus"] = 5] = "StockStatus";
            ToFileContent[ToFileContent["ItemDescription"] = 6] = "ItemDescription";
            ToFileContent[ToFileContent["ReceiverConfirmation"] = 7] = "ReceiverConfirmation";
            ToFileContent[ToFileContent["OrderConfirmation"] = 8] = "OrderConfirmation";
        })(ToFileContent = Enum.ToFileContent || (Enum.ToFileContent = {}));
        ;
        let TransactionConfirmInvoiceCreateDefault;
        (function (TransactionConfirmInvoiceCreateDefault) {
            TransactionConfirmInvoiceCreateDefault[TransactionConfirmInvoiceCreateDefault["Off"] = 0] = "Off";
            TransactionConfirmInvoiceCreateDefault[TransactionConfirmInvoiceCreateDefault["On"] = 1] = "On";
            TransactionConfirmInvoiceCreateDefault[TransactionConfirmInvoiceCreateDefault["ReceiversOnly"] = 2] = "ReceiversOnly";
            TransactionConfirmInvoiceCreateDefault[TransactionConfirmInvoiceCreateDefault["OrdersOnly"] = 3] = "OrdersOnly";
        })(TransactionConfirmInvoiceCreateDefault = Enum.TransactionConfirmInvoiceCreateDefault || (Enum.TransactionConfirmInvoiceCreateDefault = {}));
        ;
        let TransactionEntryType;
        (function (TransactionEntryType) {
            TransactionEntryType[TransactionEntryType["DoangHair"] = 0] = "DoangHair";
            TransactionEntryType[TransactionEntryType["ManualWarehouseUser"] = 1] = "ManualWarehouseUser";
            TransactionEntryType[TransactionEntryType["ManualCustomerUser"] = 2] = "ManualCustomerUser";
            TransactionEntryType[TransactionEntryType["Ftp"] = 3] = "Ftp";
            TransactionEntryType[TransactionEntryType["Api"] = 4] = "Api";
        })(TransactionEntryType = Enum.TransactionEntryType || (Enum.TransactionEntryType = {}));
        ;
        let TransactionLevelOverwrite;
        (function (TransactionLevelOverwrite) {
            TransactionLevelOverwrite[TransactionLevelOverwrite["ClearAllDetails"] = 0] = "ClearAllDetails";
            TransactionLevelOverwrite[TransactionLevelOverwrite["ClearHandlingAndStorageOnly"] = 1] = "ClearHandlingAndStorageOnly";
            TransactionLevelOverwrite[TransactionLevelOverwrite["ApplyDiffPreserveDetails"] = 2] = "ApplyDiffPreserveDetails";
        })(TransactionLevelOverwrite = Enum.TransactionLevelOverwrite || (Enum.TransactionLevelOverwrite = {}));
        ;
        let TransformFileType;
        (function (TransformFileType) {
            TransformFileType[TransformFileType["Edi"] = 0] = "Edi";
            TransformFileType[TransformFileType["Xml"] = 1] = "Xml";
            TransformFileType[TransformFileType["Other"] = 2] = "Other";
        })(TransformFileType = Enum.TransformFileType || (Enum.TransformFileType = {}));
        ;
        let TransportStrings;
        (function (TransportStrings) {
            TransportStrings["Add997SavedElement"] = "ADD997SAVEDELEMENT";
            TransportStrings["AsnSendGroupSize"] = "AsnSendGroupSize";
            TransportStrings["ConsumerKey"] = "ConsumerKey";
            TransportStrings["ConsumerSecret"] = "ConsumerSecret";
            TransportStrings["FailAllOnDupRefNum"] = "FailAllOnDupRefNum";
            TransportStrings["HeadlessHorsemanHandles"] = "HeadlessHorsemanHandles";
            TransportStrings["Import"] = "Import";
            TransportStrings["IncludeColumnNames"] = "IncludeColumnNames";
            TransportStrings["LastNotifyTime"] = "LastNotifyTime";
            TransportStrings["LastRunTime"] = "LastRunTime";
            TransportStrings["LastRunTimeUtc"] = "LastRunTimeUtc";
            TransportStrings["LastWtIdAsnSent"] = "LastWtIdAsnSent";
            TransportStrings["Login"] = "Login";
            TransportStrings["NextRunTimeUtc"] = "NextRunTimeUtc";
            TransportStrings["NumberOfAsnsToSend"] = "NumberOfAsnsToSend";
            TransportStrings["Password"] = "Password";
            TransportStrings["QueueAsnOnShip"] = "QueueAsnOnShip";
            TransportStrings["ReportAsciiDelimiter"] = "ReportAsciiDelimiter";
            TransportStrings["ReportDelimiter"] = "ReportDelimiter";
            TransportStrings["ReportFormat"] = "ReportFormat";
            TransportStrings["ReportStripHeader"] = "ReportStripHeader";
            TransportStrings["Schedule"] = "Schedule";
            TransportStrings["SendInventory"] = "SendInventory";
            TransportStrings["ServerName"] = "ServerName";
            TransportStrings["StoreRequestAndResponseInErrorLog"] = "StoreRequestAndResponceInErrorLog";
            TransportStrings["UseTodaysDate"] = "UseTodaysDate";
            TransportStrings["ImportFileName"] = "ImportFileName";
            TransportStrings["OrderId"] = "Order_Id";
        })(TransportStrings = Enum.TransportStrings || (Enum.TransportStrings = {}));
        ;
        let UCC128TemplateStrings;
        (function (UCC128TemplateStrings) {
            UCC128TemplateStrings["CartonLabelTemplate"] = "Carton Label";
            UCC128TemplateStrings["TransactionLabelTemplate"] = "Transaction Label";
        })(UCC128TemplateStrings = Enum.UCC128TemplateStrings || (Enum.UCC128TemplateStrings = {}));
        ;
        let UiRightScopeEnum;
        (function (UiRightScopeEnum) {
            UiRightScopeEnum[UiRightScopeEnum["AdminWarehouseAndCustUsers"] = 1] = "AdminWarehouseAndCustUsers";
            UiRightScopeEnum[UiRightScopeEnum["WarehouseAndCustUsers"] = 2] = "WarehouseAndCustUsers";
            UiRightScopeEnum[UiRightScopeEnum["CustUsersOnly"] = 3] = "CustUsersOnly";
        })(UiRightScopeEnum = Enum.UiRightScopeEnum || (Enum.UiRightScopeEnum = {}));
        ;
        let UiRoleScopeEnum;
        (function (UiRoleScopeEnum) {
            UiRoleScopeEnum[UiRoleScopeEnum["Customer"] = 1] = "Customer";
            UiRoleScopeEnum[UiRoleScopeEnum["Warehouse"] = 2] = "Warehouse";
            UiRoleScopeEnum[UiRoleScopeEnum["SuperAdmin"] = 3] = "SuperAdmin";
        })(UiRoleScopeEnum = Enum.UiRoleScopeEnum || (Enum.UiRoleScopeEnum = {}));
        ;
        let UpsMode;
        (function (UpsMode) {
            UpsMode[UpsMode["Test"] = 0] = "Test";
            UpsMode[UpsMode["Production"] = 1] = "Production";
        })(UpsMode = Enum.UpsMode || (Enum.UpsMode = {}));
        ;
        let UsageLevel;
        (function (UsageLevel) {
            UsageLevel[UsageLevel["Disallow"] = 0] = "Disallow";
            UsageLevel[UsageLevel["Allow"] = 1] = "Allow";
            UsageLevel[UsageLevel["Require"] = 2] = "Require";
        })(UsageLevel = Enum.UsageLevel || (Enum.UsageLevel = {}));
        ;
        let V1SessionDataType;
        (function (V1SessionDataType) {
            V1SessionDataType[V1SessionDataType["ArrayOfInteger"] = 0] = "ArrayOfInteger";
            V1SessionDataType[V1SessionDataType["Integer"] = 1] = "Integer";
            V1SessionDataType[V1SessionDataType["String"] = 2] = "String";
        })(V1SessionDataType = Enum.V1SessionDataType || (Enum.V1SessionDataType = {}));
        ;
        let WarehouseTransactionApiStatus;
        (function (WarehouseTransactionApiStatus) {
            WarehouseTransactionApiStatus[WarehouseTransactionApiStatus["Open"] = 0] = "Open";
            WarehouseTransactionApiStatus[WarehouseTransactionApiStatus["Closed"] = 1] = "Closed";
            WarehouseTransactionApiStatus[WarehouseTransactionApiStatus["Canceled"] = 2] = "Canceled";
        })(WarehouseTransactionApiStatus = Enum.WarehouseTransactionApiStatus || (Enum.WarehouseTransactionApiStatus = {}));
        ;
        let WarehouseTransactionEventNotificationSentFlag;
        (function (WarehouseTransactionEventNotificationSentFlag) {
            WarehouseTransactionEventNotificationSentFlag[WarehouseTransactionEventNotificationSentFlag["NotApplicable"] = 0] = "NotApplicable";
            WarehouseTransactionEventNotificationSentFlag[WarehouseTransactionEventNotificationSentFlag["OrderCreate"] = 1] = "OrderCreate";
            WarehouseTransactionEventNotificationSentFlag[WarehouseTransactionEventNotificationSentFlag["OrderConfirm"] = 2] = "OrderConfirm";
            WarehouseTransactionEventNotificationSentFlag[WarehouseTransactionEventNotificationSentFlag["OrderCancel"] = 4] = "OrderCancel";
            WarehouseTransactionEventNotificationSentFlag[WarehouseTransactionEventNotificationSentFlag["ReceiverCreate"] = 8] = "ReceiverCreate";
            WarehouseTransactionEventNotificationSentFlag[WarehouseTransactionEventNotificationSentFlag["ReceiverConfirm"] = 16] = "ReceiverConfirm";
            WarehouseTransactionEventNotificationSentFlag[WarehouseTransactionEventNotificationSentFlag["ReceiverCancel"] = 32] = "ReceiverCancel";
            WarehouseTransactionEventNotificationSentFlag[WarehouseTransactionEventNotificationSentFlag["AdjustmentCreate"] = 64] = "AdjustmentCreate";
            WarehouseTransactionEventNotificationSentFlag[WarehouseTransactionEventNotificationSentFlag["OrderPacked"] = 128] = "OrderPacked";
        })(WarehouseTransactionEventNotificationSentFlag = Enum.WarehouseTransactionEventNotificationSentFlag || (Enum.WarehouseTransactionEventNotificationSentFlag = {}));
        ;
        let WarehouseTransactionSourceType;
        (function (WarehouseTransactionSourceType) {
            WarehouseTransactionSourceType[WarehouseTransactionSourceType["Unknown"] = 0] = "Unknown";
            WarehouseTransactionSourceType[WarehouseTransactionSourceType["UiManual"] = 1] = "UiManual";
            WarehouseTransactionSourceType[WarehouseTransactionSourceType["UiImport"] = 2] = "UiImport";
            WarehouseTransactionSourceType[WarehouseTransactionSourceType["AutomatedImport"] = 3] = "AutomatedImport";
            WarehouseTransactionSourceType[WarehouseTransactionSourceType["ExternalSoapApi"] = 4] = "ExternalSoapApi";
            WarehouseTransactionSourceType[WarehouseTransactionSourceType["QuickBooksSoapApi"] = 5] = "QuickBooksSoapApi";
            WarehouseTransactionSourceType[WarehouseTransactionSourceType["AutomatedSystemCharge"] = 6] = "AutomatedSystemCharge";
            WarehouseTransactionSourceType[WarehouseTransactionSourceType["RestApi"] = 7] = "RestApi";
        })(WarehouseTransactionSourceType = Enum.WarehouseTransactionSourceType || (Enum.WarehouseTransactionSourceType = {}));
        ;
        let WarehouseTransactionStatus;
        (function (WarehouseTransactionStatus) {
            WarehouseTransactionStatus[WarehouseTransactionStatus["Default"] = 0] = "Default";
            WarehouseTransactionStatus[WarehouseTransactionStatus["NotVerified"] = 1] = "NotVerified";
            WarehouseTransactionStatus[WarehouseTransactionStatus["Verified"] = 2] = "Verified";
            WarehouseTransactionStatus[WarehouseTransactionStatus["Canceled"] = 3] = "Canceled";
        })(WarehouseTransactionStatus = Enum.WarehouseTransactionStatus || (Enum.WarehouseTransactionStatus = {}));
        ;
        let WarehouseTransactionType;
        (function (WarehouseTransactionType) {
            WarehouseTransactionType[WarehouseTransactionType["Default"] = 0] = "Default";
            WarehouseTransactionType[WarehouseTransactionType["Inbound"] = 1] = "Inbound";
            WarehouseTransactionType[WarehouseTransactionType["Order"] = 2] = "Order";
            WarehouseTransactionType[WarehouseTransactionType["Adjust"] = 3] = "Adjust";
            WarehouseTransactionType[WarehouseTransactionType["Assembly"] = 4] = "Assembly";
        })(WarehouseTransactionType = Enum.WarehouseTransactionType || (Enum.WarehouseTransactionType = {}));
        ;
    })(Enum = Common.Enum || (Common.Enum = {}));
})(Common || (Common = {}));
exports.Common = Common;
